var Vendd = (function (Vendd) {
    'use strict';
    /*
     * ERROR CODE
     * ---------------
     * 1000     INVALID CONFIGURATOR ITEM ID
     * 1001     CONFIGURATOR NOT FOUND / INITIALIZED
     * 1002     INVALID CONFIGURATOR MODEL DATA
     * 1003     INVALID OPTIONAL ITEM ID
     * 1004     INVALID CONFIGURATOR VALUES 
     * 1010     MIN QUANTITY OF OPTIONAL ITEM
     * 1011     MAX QUANTITY OF OPTIONAL ITEM
     * 1012     DEFAULT OPTIONAL ITEM CAN NOT REMOVE
     * 1020     MIN QUANTITY FOR GROUP OF OPTIONAL ITEMS
     * 1021     MAX QUANTITY FOR GROUP OF OPTIONAL ITEMS
     * 1040     MIN QUANTITY FOR ALL ITEMS
     * 1041     MAX QUANTITY FOR ALL ITEMS
     * 1030     INCOMATIBLE OPTIONAL ITEM
     * 1031     PREREQUISITES FOR OPTIONAL ITEM NOT EXIST
     * 1032     ERROR CODE 1030 & ERROR CODE 1031
     * 1033     NOT EXISTS ANY OF REQUIRED INGREDIENTS
     * 1034     INGREDIENT DISABLED FROM SELECTED SUBRECIPE
     * 1035     INGREDIENT DISABLED FROM MASTER RECIPE
     * 1036     INGREDIENT DISABLE AS AUTO ADD OPTION
     * 1050     NO LOCAL STORAGE CONFIGURATOR MODEL SAVED
     * 1060     ERROR SAVING DATA
     * 1061     ERROR SAVING DATA - NOT SET CONFIGURATOR ITEM ID
     * 1070     OUTDATED LOADED DATA
     * 1071     ERROR LOADING DATA - NOT GLOBALID SET
     * 1072     ERROR LOADING DATA - SAVED INGREDIENT DOES NOT EXISTS ANY MORE
     * 1073     ERROR LOADING DATA - SAVED INGREDIENT CHANGE PRICE
     * 1074     ERROR LOADING DATA - SAVED INGREDIENT CHANGE INCOMPATIBLES
     * 1075     ERROR LOADING DATA - SAVED INGREDIENT CHANGE PREREQUISITES
     * 1080     ERROR DEPEDENCIES   - ADD AND REMOVE SAME ITEM
     * 1081     ERROR DEPEDENCIES   - ADD ITEMS FROM SAME SINGLE GROUP
     * 1082     ERROR DEPEDENCIES   - REMOVE ITEM CANNOT REMOVED
     * */
    var _recipes = {};
    var _recipesOld = {};
    var returnResponse = function (recipeId, statusCode, errorCodes, data) {


        return {
            success: statusCode === 200,
            data: data || {},
            status: {
                statusCode: statusCode,
                recipeId: recipeId,
                ErrorCode: errorCodes || [],
                ErrorCodes: errorCodes || []
            }
        }
    };

    var getRecipe = function (model, recipeId) {

        var recipeModel = model ? model : testModel,
            recipe = _.isArray(recipeModel) ? _.first(_.filter(recipeModel, function (x) { return x.RecipeId === recipeId && x.TotalCount > 0; })) : recipeModel;

        return $.extend(true, {}, recipe);
    };

    var getTotalQuantity = function (model, ingredientId) {
        var items = _.filter(model.RecipeItems, function (item) { return item.IngredientId !== ingredientId; });
        return _.reduce(items, function (memo, item) { return memo + (item.Quantity || 0); }, 0);
    }

    var getGroupQuantity = function (model, group, ingredientId) {
        var items = _.filter(model.RecipeItems, function (item) { return item.GroupId === group.Id && item.IngredientId !== ingredientId; });
        return _.reduce(items, function (memo, item) { return memo + (item.Quantity || 0); }, 0);
    }

    var getTotalWeight = function (model, ingredientId) {
        var items = _.filter(model.RecipeItems, function (item) { return item.IngredientId !== ingredientId; });
        var recipeItemsWeight = _.reduce(items, function (memo, item) { return memo + (item.Weight || 0); }, 0);
        var addonsWeight = _.reduce(model.Addons, function (memo, item) { return memo + (item.Weight || 0); }, 0);
        var totalWeight = recipeItemsWeight + addonsWeight;
        return totalWeight;
    }

    var getTotalGrossWeight = function (model, ingredientId) {
        var items = _.filter(model.RecipeItems, function (item) { return item.IngredientId !== ingredientId; });
        var recipeItemsWeight = _.reduce(items, function (memo, item) { return memo + (item.GrossWeight || 0); }, 0);
        //var addonsWeight = _.reduce(model.Addons, function (memo, item) { return memo + (item.GrossWeight || 0); }, 0);
        //var totalWeight = recipeItemsWeight + addonsWeight;
        return recipeItemsWeight;
    }

    var getTotalIngredientsCo2 = function (model) {
        return _.reduce(model.RecipeItems, function (memo, item) { return memo + ((item.Quantity || 0) * (item.Co2 || 0)); }, 0);
    }

    var getTotalAddonsCo2 = function (model) {
        return _.reduce(model.Addons, function (memo, item) { return memo + ((item.Quantity || 0) * (item.Co2 || 0)); }, 0);
    }

    Vendd.RecipeLibrary = Vendd.RecipeLibrary || {};
    Vendd.RecipeLibrary.Literals = Vendd.RecipeLibrary.Literals || {};
    Vendd.RecipeLibrary.Literals.NoneOfBelow = "None of below";

    Vendd.RecipeLibrary.PriceFormat = function (x) { // AL - Format Price
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    Vendd.RecipeLibrary.AddVat = function (recipeId, x) { // AL - Add Vat
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return 0;
        }
        return x * (recipe.Vat / 100 + 1);
    }

    Vendd.RecipeLibrary.RemoveVat = function (recipeId, x) { // AL - Remove Vat
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return 0;
        }
        return x / (100 + recipe.Vat) * 100;
    }

    Vendd.RecipeLibrary.DeclareState = function (model, recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        model.Prices = model.Prices || _recipes[recipeId].Prices || {};
        model.ExternalProductImageIsEnabled = _recipes[recipeId].ExternalProductImageIsEnabled || false;
        model.ExternalProductImageData = _recipes[recipeId].ExternalProductImageData;
        _recipes[recipeId] = model;
        var data = {};
        data.recipe = $.extend(true, {}, model);
        data.isValid = checkRestrictions(model);
        setRecipeItemsToProduct(recipeId);
        return returnResponse(recipeId, 200, [], data);
    };

    var setRecipeItemsToProduct = function (recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return;
        }
        var ingredientsWithDefaultQuantityRemoved = _.filter(recipe.Ingredients, function (i) { return i.DefaultQuantity > 0 && !recipe.RecipeItems.some(function (r) { return r.ProductItemId === i.RecipeItemId; }); }) || [];
        var recipeItems = _.map(ingredientsWithDefaultQuantityRemoved || [], function (i) {
            return {
                Quantity: 0,
                ParentProductId: i.RecipeItemId,
                RecipeItemId: i.RecipeItemId
            };
        });
        recipeItems = recipeItems.concat(
            _.map(recipe.RecipeItems, function (i) {
                return {
                    Quantity: i.Quantity,
                    ParentProductId: i.ProductItemId,
                    RecipeItemId: i.ProductItemId
                };
            }) || []
        );
        try {
            Vendd.MessageBus.publishAsync(null, new Vendd.Product.Messages.SetRecipeItems(recipeItems));
        }
        catch { }
    }

    Vendd.RecipeLibrary.GetModel = function (recipeId) {

        if (!_recipes[recipeId]) {
            return returnResponse(recipeId, 500, [1000]);
        }

        return returnResponse(recipeId, 200, [], _recipes[recipeId]);
    };

    Vendd.RecipeLibrary.InitRecipe = function (model, recipeId, sortIngredientsBy, force) {
        force = force || false;
        if (_recipes[recipeId] && !force) {
            return returnResponse(recipeId, 500, [1000]);
        }
        var recipe = getRecipe(model, recipeId);
        if (!recipe) {
            return returnResponse(recipeId, 500, [1001]);
        }
        _recipes[recipeId] = recipe;

        recipe.Vat = recipe.UnitPrice !== recipe.UnitPriceWithoutVat ? 100 * (parseFloat(recipe.UnitPrice / recipe.UnitPriceWithoutVat).toFixed(2) - 1) : 0;

        _recipes[recipeId].AFirstInclusion = 1;

        _recipes[recipeId].Ingredients = [];
        _recipes[recipeId].Groups = [];
        _recipes[recipeId].RecipeItems = [];

        _recipes[recipeId].Addons = model.Addons || [];

        if ((recipe.Co2AttributeCode || "") !== "") {
            recipe.Co2 = parseFloat((_.find(recipe.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.Co2AttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || "0");
        }
        if ((recipe.FuelTypeCodeAttributeCode || "") !== "") {
            recipe.FuelTypeCode = (_.find(recipe.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.FuelTypeCodeAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || "";
        }
        if ((recipe.EngineDisplacementAttributeCode || "") !== "") {
            recipe.EngineDisplacement = parseFloat((_.find(recipe.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.EngineDisplacementAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || "0") || 0;
        }
        if ((recipe.VehicleTypeCodeAttributeCode || "") !== "") {
            recipe.VehicleTypeCode = (_.find(recipe.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.VehicleTypeCodeAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || "";
        }
        if ((recipe.BodyStyleCodeAttributeCode || "") !== "") {
            recipe.BodyStyleCode = (_.find(recipe.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.BodyStyleCodeAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || "";
        }
        if ((recipe.GrossWeightAttributeCode || "") !== "") {
            recipe.GrossWeight = parseFloat((_.find(recipe.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.GrossWeightAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || "0");
        }
        if ((recipe.NumberOfSeatsAttributeCode || "") !== "") {
            recipe.NumberOfSeats = parseInt((_.find(recipe.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.NumberOfSeatsAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || "0");
        }
        
        $.each(recipe.Categories, function (indexCategory, category) {
            $.each(category.Groups, function (indexGroup, group) {
                $.each(group.VisualGroups, function (indexGroup, visualgroup) {
                    var groupItems = _.reduce(group.VisualGroups, function (sum, vg) { return (vg.Items.length || 0) + sum; }, 0);
                    group.IsMultiSelect = !(group.MinQuantity <= 1 && group.MaxQuantity === 1 && groupItems > 1);
                    group.DefaultQuantities = 0;

                    if (!group.IsMultiSelect && group.MinQuantity === 0) {
                        var sampleOptionItemNone = {
                            CanRemove: true,
                            Category: category.Category,
                            DefaultQuantity: 0,
                            DeletedPrice: 0,
                            DeletedPriceText: "",
                            Price: 0,
                            PriceText: "",
                            PriceWithoutVat: 0,
                            PriceWithoutVatText: "",
                            MinQuantity: 0,
                            MaxQuantity: 1,
                            Weight: 0,
                            GrossWeight: 0,
                            Name: Vendd.RecipeLibrary.Literals.NoneOfBelow,
                            OrderNumber: 0,
                            Quanta: 1,
                            QuantaText: "",
                            RecipeGroupId: group.Id,
                            RecipeGroupName: group.Name,
                            IngredientId: 0,
                            Stock: 1,
                            TaxClassId: 0,
                            VariantId: 0,
                            OptionType: true,
                            IsNullable: true
                        };
                        visualgroup.Items.unshift(sampleOptionItemNone);
                    }

                    $.each(visualgroup.Items, function (indexItem, item) {
                        //fix wrong default value from min-max item quantity
                        group.DefaultQuantities += item.DefaultQuantity;
                        item.HasValidDefaultValues = item.MinQuantity <= item.DefaultQuantity && item.MaxQuantity >= item.DefaultQuantity;
                        item.DefaultQuantity = item.MinQuantity > item.DefaultQuantity ? item.MinQuantity : item.MaxQuantity < item.DefaultQuantity ? item.MaxQuantity : item.DefaultQuantity;
                        item.IsMandatory = (item.MinQuantity === item.DefaultQuantity && item.DefaultQuantity > 0) || !item.CanRemove;
                        item.Disabled = (item.MinQuantity === item.DefaultQuantity && item.MaxQuantity === item.DefaultQuantity && item.DefaultQuantity > 0) || !item.CanRemove;
                        item.Checked = item.IsDefault;
                        item.IsAutoAddIngredient = (item.CanBeAutoAddedFrom || []).length > 0;
                        //item.Attributes = [{ "Code": "Co2", "Value": "10" }];
                        if ((recipe.Co2AttributeCode || "") !== "") {
                            item.Co2 = parseFloat((_.find(item.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").replace("ItemAttributes_", "").toLowerCase() === recipe.Co2AttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || "0");
                        }
                        if ((recipe.DMSCodeAttributeCode || "") !== "") {
                            item.DMSCode = (_.find(item.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.DMSCodeAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || "";
                        }

                        if ((recipe.GrossWeightAttributeCode || "") !== "") {
                            item.GrossWeight = parseFloat((_.find(item.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.GrossWeightAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || "0");
                        }
                        item.GroupId = group.Id;
                        item.IsGroupMultiSelect = group.IsMultiSelect;
                        item.SingleGroupIngredients = [];
                        item.IsRequiredBy = [];
                        item.IsRequiredByAnyOfSet = [];
                        var ingredient = item;
                        _recipes[recipeId].Ingredients.push(ingredient);
                        if (item.Price <= 0) {
                            item.Price = 0;
                            item.PriceText = "";
                            item.PriceWithoutVatText = "";
                        }
                        if (ingredient.DefaultQuantity > 0) {
                            _recipes[recipeId].RecipeItems.push({
                                RecipeId: recipeId,
                                Category: ingredient.Category,
                                CategoryCode: ingredient.CategoryCode,
                                ManufacturerProductCode: ingredient.ManufacturerProductCode,
                                GroupId: group.Id,
                                IngredientId: ingredient.IngredientId,
                                ProductItemCode: ingredient.RecipeItemCode,
                                ProductItemId: ingredient.RecipeItemId,
                                VariantId: ingredient.VariantId,
                                Name: ingredient.Name || "",
                                Quantity: ingredient.DefaultQuantity,
                                Price: 0,//(Math.round(ingredient.Price * 100) / 100) * ingredient.DefaultQuantity,
                                PriceWithoutVat: 0,
                                TotalPrice: 0,
                                TotalPriceWithoutVat: 0,
                                Weight: ingredient.Weight || 0,
                                GrossWeight: ingredient.GrossWeight || 0,
                                IsStandard: ingredient.DefaultQuantity > 0,
                                IsStandardExcludePackage: ingredient.DefaultQuantity > 0,
                                IsMandatory: ingredient.IsMandatory,
                                OptionType: ingredient.OptionType,
                                SubRecipeId: ingredient.SubRecipeId,
                                SubRecipeCode: ingredient.SubRecipeCode,
                                Attributes: ingredient.Attributes
                            });
                        }
                    });

                    if (sortIngredientsBy) {
                        visualgroup.Items = _.sortBy(visualgroup.Items, sortIngredientsBy);
                    }

                    group.HasValidDefaultValues = group.MinQuantity <= group.DefaultQuantities && group.MaxQuantity >= group.DefaultQuantities;
                    if (!group.IsMultiSelect && group.DefaultQuantities === 0 && group.MinQuantity === 0) {
                        var defaultItem = visualgroup.Items[0];
                        defaultItem.Checked = true;
                    }
                    _recipes[recipeId].Groups.push(group);
                });
            });
        });

        $.each(_.filter(recipe.Ingredients, function (i) { return i.SubRecipeId && i.SubRecipe; }) || []
            , function (i, s) {
                Vendd.RecipeLibrary.InitRecipe(s.SubRecipe, s.RecipeItemId, sortIngredientsBy, force);
            });

        $.each(recipe.Ingredients || []
            , function (i, ingredient) {
                var hasIncompatibles = ingredient.Incompatibles.length > 0;
                var hasRequires = ingredient.Prerequisites.length > 0 || (_.find(recipe.Ingredients, function (pItem) { return pItem.Prerequisites.indexOf(ingredient.IngredientId) > -1 })) || false;
                var hasRequiresAnyOfSet = ingredient.RequiresAnyOfSet.length > 0 || (_.find(recipe.Ingredients, function (pItem) { return pItem.RequiresAnyOfSet.indexOf(ingredient.IngredientId) > -1 })) || false;
                var hasAutoAdd = (ingredient.AutoAdd || []).length > 0 || (_.find(recipe.Ingredients, function (pItem) { return (pItem.AutoAdd || []).indexOf(ingredient.IngredientId) > -1 })) || false;
                ingredient.HasRelationshipRule = hasIncompatibles || hasRequires || hasRequiresAnyOfSet || hasAutoAdd;
                if (ingredient.DefaultQuantity > 0 && hasAutoAdd) {
                    (ingredient.AutoAdd || []).forEach((ingredientIdTo) => {
                        var result = Vendd.RecipeLibrary.AddIngredient(recipe, recipeId, ingredientIdTo, 1, true);
                    });
                }
                ingredient.SingleGroupIngredients = ingredient.IsGroupMultiSelect ? [] :
                    _.map(
                        _.filter(recipe.Ingredients, function (gi) { return gi.GroupId === ingredient.GroupId && gi.IngredientId !== ingredient.IngredientId; }) || [],
                        function (gi) { return gi.IngredientId; }
                    );
                _.each((ingredient.Prerequisites || []), function (prerequisite) {
                    var _ingredients = _.find(recipe.Ingredients, function (x) { return x.IngredientId === prerequisite; });
                    if (!_ingredients) return;
                    _ingredients.IsRequiredBy.push(ingredient.IngredientId);
                });
                _.each((ingredient.RequiresAnyOfSet || []), function (set) {
                    _.each((set.RequiresAnyOfItems || []), function (prerequisite) {
                        var _ingredients = _.find(recipe.Ingredients, function (x) { return x.IngredientId === prerequisite; });
                        if (!_ingredients) return;
                        _ingredients.IsRequiredByAnyOfSet.push({
                            "SetId": set.SetId,
                            "IsRequiredByAnyOfSetItem": ingredient.IngredientId
                        });
                    });
                });
                
            });

        _recipes[recipeId].HashCode = getRecipeItemsHashCode(recipeId);

        if (localStorage.getItem("globalId_" + recipeId) !== null) {
            localStorage.removeItem("globalId_" + recipeId);
        }

        return Vendd.RecipeLibrary.DeclareState(recipe, recipeId);
    };

    Vendd.RecipeLibrary.ResetRecipe = function (model, recipeId) {

        if (!_recipes[recipeId]) {
            return returnResponse(recipeId, 500, [1000]);
        }
        var recipe = getRecipe(model, recipeId);

        if (!recipe) {
            return returnResponse(recipeId, 500, [1001]);
        }
        //reinitialize
        delete _recipes[recipeId];
        _recipes[recipeId] = recipe;

        if (localStorage.getItem("globalId_" + recipeId) !== null) {
            localStorage.removeItem("globalId_" + recipeId);
        }
        return Vendd.RecipeLibrary.DeclareState(model, recipeId);
    };

    Vendd.RecipeLibrary.AddIngredient = function (model, recipeId, ingredientId, quantity, isTotal, checkAutoAdd) {
        var recipe = _recipes[recipeId];

        if (!_recipes[recipeId]) {
            return returnResponse(recipeId, 500, [1000]);
        }

        if (!recipe) {
            return returnResponse(recipeId, 500, [1001]);
        }

        checkAutoAdd = checkAutoAdd !== false;
        var group = null;
        var ingredient = _.find(model.Ingredients, function (i) { return i.IngredientId === ingredientId; });
        if (ingredient) group = _.find(model.Groups, function (g) { return g.Id === ingredient.GroupId; });

        if (!(ingredient && group)) {
            return returnResponse(recipeId, 500, [1003]);
        }
        var errorCodes = [];

        var isCompatible = (Vendd.RecipeLibrary.CheckIncompatibles(recipeId, ingredientId)).success;
        var responsePrerequisites = (Vendd.RecipeLibrary.CheckPrerequisites(recipeId, ingredientId));
        var successPrerequisites = responsePrerequisites.success || (!responsePrerequisites.success && responsePrerequisites.data.BothPrerequisite);

        var recipeIngredient = _.first(_.filter(model.RecipeItems, function (x) { return x.IngredientId === ingredientId && x.RecipeId === recipeId; }));
        if (!isCompatible) errorCodes.push(1030);
        if (!successPrerequisites) errorCodes.push(1031);
        //if (!isCompatible || !successPrerequisites) {
        //    var errorCode = !isCompatible && !successPrerequisites ? 1032 : !isCompatible ? 1030 : 1031;
        //    return returnResponse(recipeId, 500, errorCode);
        //}

        var responsePrerequisitesAnyOfSet = (Vendd.RecipeLibrary.CheckPrerequisitesAnyOfSet(recipeId, ingredientId));
        var successPrerequisitesAnyOfSet = responsePrerequisitesAnyOfSet.success || (!responsePrerequisitesAnyOfSet.success && responsePrerequisitesAnyOfSet.data.BothPrerequisite);
        if (!successPrerequisitesAnyOfSet) errorCodes.push(1033);
        //if (!successPrerequisitesAnyOfSet) {
        //    return returnResponse(recipeId, 500, 1033);
        //}
        var totalIngredientQuantity = isTotal ? quantity : ((recipeIngredient || {}).Quantity || 0) + quantity;
        totalIngredientQuantity = totalIngredientQuantity > 0 ? totalIngredientQuantity : 0;
        if (ingredient.MinQuantity && totalIngredientQuantity < ingredient.MinQuantity) errorCodes.push(1010);
        //if (ingredient.MinQuantity && totalIngredientQuantity < ingredient.MinQuantity) {
        //    return returnResponse(recipeId, 500, 1010);
        //}
        if (ingredient.MaxQuantity && totalIngredientQuantity > ingredient.MaxQuantity) errorCodes.push(1011);
        //if (ingredient.MaxQuantity && totalIngredientQuantity > ingredient.MaxQuantity) {
        //    return returnResponse(recipeId, 500, 1011);
        //}
        var maxGroupQuantity = group.MaxQuantity || 0;
        var groupQuantity = getGroupQuantity(model, group, ingredientId);

        if (maxGroupQuantity < groupQuantity + totalIngredientQuantity) errorCodes.push(1021);
        //if (maxGroupQuantity < groupQuantity + totalIngredientQuantity) {
        //    return returnResponse(recipeId, 500, 1021);
        //}
        var maxQuantity = recipe.MaxQuantity || 0;
        var totalQuantity = getTotalQuantity(model, ingredientId);

        if (maxQuantity < totalQuantity + totalIngredientQuantity) errorCodes.push(1041);
        //if (maxQuantity < totalQuantity + totalIngredientQuantity) {
        //    return returnResponse(recipeId, 500, 1041);
        //}

        var price = (Math.round(ingredient.Price * 100) / 100);//* totalIngredientQuantity;
        var priceWithoutVat = (Math.round(ingredient.PriceWithoutVat * 100) / 100);//* totalIngredientQuantity;


        if (model.ParentRecipeId > 0) {
            var parentModel = Vendd.RecipeLibrary.GetModel(model.ParentRecipeItemId) || {};
            var parentIngredient = _.find(parentModel.Ingredients, function (i) { return i.VariantId === ingredient.VariantId; }) || {};
            if ((parentIngredient.IngredientId || 0) > 0) {
                var recipeAddResult = Vendd.RecipeLibrary.AddIngredient(parentModel, model.ParentRecipeItemId, parentIngredient.IngredientId, ingredient.Quantity, true);
                if (!recipeAddResult.success) errorCodes.push(1034);
                //if (!recipeAddResult.success) {
                //    return returnResponse(recipeId, 500, 1034);
                //};
            }
        }

        if (errorCodes.length > 0) {
            return returnResponse(recipeId, 500, errorCodes);
        };

        if (recipeIngredient) {
            recipeIngredient.Quantity = totalIngredientQuantity;
            recipeIngredient.Price = price;
            recipeIngredient.PriceWithoutVat = priceWithoutVat;
        } else {
            model.RecipeItems.push({
                RecipeId: recipeId,
                Category: ingredient.Category,
                CategoryCode: ingredient.CategoryCode,
                ManufacturerProductCode: ingredient.ManufacturerProductCode,
                GroupId: group.Id,
                IngredientId: ingredient.IngredientId,
                ProductItemCode: ingredient.RecipeItemCode,
                ProductItemId: ingredient.RecipeItemId,
                VariantId: ingredient.VariantId,
                Name: ingredient.Name || "",
                Quantity: quantity,
                Price: price,
                PriceWithoutVat: priceWithoutVat,
                TotalPrice: Math.max(totalIngredientQuantity - ingredient.DefaultQuantity, 0) * price,
                TotalPriceWithoutVat: Math.max(totalIngredientQuantity - ingredient.DefaultQuantity, 0) * priceWithoutVat,
                Weight: ingredient.Weight,
                GrossWeight: ingredient.GrossWeight,
                IsStandard: ingredient.DefaultQuantity > 0,
                IsStandardExcludePackage: ingredient.DefaultQuantity > 0,
                IsMandatory: ingredient.IsMandatory,
                OptionType: ingredient.OptionType,
                SubRecipeId: ingredient.SubRecipeId,
                SubRecipeCode: ingredient.SubRecipeCode,
                Attributes: ingredient.Attributes
            });
        }

        if (checkAutoAdd) {
            var autoAdds = [];

            (model.RecipeItems || []).forEach((recipeItem) => {
                var recipeIngredient = _.find(model.Ingredients, function (i) { return i.IngredientId === recipeItem.IngredientId; });
                var notExistingAutoAdd = _.filter((recipeIngredient.AutoAdd || []), function (i) {
                    return !model.RecipeItems.some(function (recipeAutoAdd) {
                        return i === recipeAutoAdd.IngredientId;
                    });
                });
                autoAdds = autoAdds.concat(notExistingAutoAdd);
            });
            autoAdds = _.uniq(autoAdds);
            if ((autoAdds || []).length > 0) Vendd.RecipeLibrary.DeclareState(model, recipeId);
            (autoAdds || []).forEach((ingredientIdTo) => {

                var result = Vendd.RecipeLibrary.AddIngredient(model, recipeId, ingredientIdTo, 1, true, false);
            });
        }

        model.HashCode = getRecipeItemsHashCode(recipeId);

        return Vendd.RecipeLibrary.DeclareState(model, recipeId);
    };

    Vendd.RecipeLibrary.AddNewAddon = function (model, recipeId, addonObj) {
        var recipe = _recipes[recipeId];

        if (!_recipes[recipeId]) {
            return returnResponse(recipeId, 500, [1000]);
        }

        if (!recipe) {
            return returnResponse(recipeId, 500, [1001]);
        }

        var addonInModel = _.find(model.Addons, function (modelAddon) { return modelAddon.AddonId === addonObj.Id; })                
        if (typeof addonInModel === 'object') { // Addon is already in model.Addons 
            addonInModel.Name = addonObj.Name;
            addonInModel.Price = addonObj.Price;
            addonInModel.PriceWithoutVat = addonObj.PriceWithoutVat;
            addonInModel.Code = addonObj.Code;
            addonInModel.Weight = addonObj.Weight;
            addonInModel.Co2 = addonObj.Co2;
            
            return Vendd.RecipeLibrary.DeclareState(model, recipeId);
        }

        var item = { // Addon is New
            RecipeId: recipeId,
            Category: 'Addons',
            AddonId: addonObj.Id,
            Name: addonObj.Name,
            Price: addonObj.Price,
            PriceWithoutVat: addonObj.PriceWithoutVat,
            Code: addonObj.Code,
            Weight: addonObj.Weight,
            Co2: addonObj.Co2,
        }

        model.Addons.push(item);

        return Vendd.RecipeLibrary.DeclareState(model, recipeId);
    };

    Vendd.RecipeLibrary.RemoveAddon = function (model, recipeId, addonObj) {
        var recipe = _recipes[recipeId];

        if (!_recipes[recipeId]) {
            return returnResponse(recipeId, 500, [1000]);
        }

        if (!recipe) {
            return returnResponse(recipeId, 500, [1001]);
        }

        model.Addons = _.filter(model.Addons, function (item) {
            return item.AddonId !== addonObj.Id
        });
        
        return Vendd.RecipeLibrary.DeclareState(model, recipeId);
    };

    Vendd.RecipeLibrary.RemoveIngredient = function (model, recipeId, ingredientId, quantity, recursive, force) {
        force = force === undefined ? true : force;
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1001]);
        }

        var group = null;
        var ingredient = _.find(model.Ingredients, function (i) { return i.IngredientId === ingredientId; });
        if (ingredient) group = _.find(model.Groups, function (g) { return g.Id === ingredient.GroupId; });

        if (!(ingredient && group)) {
            return returnResponse(recipeId, 500, [1003]);
        }

        var recipeIngredient = _.first(_.filter(model.RecipeItems, function (x) { return x.IngredientId === ingredientId && x.RecipeId === recipeId; }));

        var totalIngredientQuantity = recursive ? 0 : ((recipeIngredient || {}).Quantity || 0) - quantity;
        totalIngredientQuantity = totalIngredientQuantity > 0 ? totalIngredientQuantity : 0;

        if (ingredient.MinQuantity && totalIngredientQuantity < ingredient.MinQuantity) {
            return returnResponse(recipeId, 500, [1010]);
        }

        var minGroupQuantity = group.MinQuantity || 0;
        var groupQuantity = getGroupQuantity(model, group, ingredientId);

        if (minGroupQuantity > groupQuantity + totalIngredientQuantity && !force) {
            return returnResponse(recipeId, 500, [1020]);
        }
        var minQuantity = recipe.MinQuantity || 0;
        var totalQuantity = getTotalQuantity(model, ingredientId);

        if (minQuantity > totalQuantity + totalIngredientQuantity && !force) {
            return returnResponse(recipeId, 500, [1040]);
        }

        if (recipeIngredient && totalIngredientQuantity > 0) {
            recipeIngredient.Quantity = totalIngredientQuantity;
            recipeIngredient.Price = price;
        } else {
            model.RecipeItems = _.filter(model.RecipeItems, function (x) { return x.IngredientId !== ingredientId; });
        }

        removeRelativeIngredients(model, recipeId, ingredient);

        model.HashCode = getRecipeItemsHashCode(recipeId);

        return Vendd.RecipeLibrary.DeclareState(model, recipeId);

    };

    Vendd.RecipeLibrary.ChangeIngredient = function (model, recipeId, ingredientIdFrom, ingredientIdTo) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1001]);
        }

        var groupFrom = null;
        var ingredientFrom = _.find(model.Ingredients, function (i) { return i.IngredientId === ingredientIdFrom; });
        if (ingredientFrom) groupFrom = _.find(model.Groups, function (g) { return g.Id === ingredientFrom.GroupId; });

        if (!(ingredientFrom && groupFrom)) {
            return returnResponse(recipeId, 500, [1003]);
        }

        var recipeIngredientFrom = _.first(_.filter(model.RecipeItems, function (x) { return x.IngredientId === ingredientIdFrom && x.RecipeId === recipeId; }));

        if (!recipeIngredientFrom) {
            return returnResponse(recipeId, 500, [1002]);
        }

        model.RecipeItems = _.filter(model.RecipeItems, function (x) { return x.IngredientId !== ingredientIdFrom; });

        removeRelativeIngredients(model, recipeId, ingredientFrom);

        var result = Vendd.RecipeLibrary.AddIngredient(model, recipeId, ingredientIdTo, 1, true);

        model.HashCode = getRecipeItemsHashCode(recipeId);

        if (result.success) return result;

        return Vendd.RecipeLibrary.DeclareState(model, recipeId);

    };

    var removeRelativeIngredients = function (model, recipeId, ingredient) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return returnResponse(recipeId, 500, [1001]);
        }
        var ingredientId = ingredient.IngredientId;
        var prerequisiteIngredients = _.map(_.filter(model.Ingredients,
            function (i) {
                return i.Prerequisites && i.Prerequisites.indexOf(ingredientId) > -1 && model.RecipeItems.some(function (item) { return item.IngredientId === i.IngredientId });
            }) || [],
            function (i) {
                return i.IngredientId;
            });

        var autoAddIngredients = _.filter(ingredient.AutoAdd || [],
            function (autoAddIngredientId) {
                var autoAddIngredient = _.find(model.Ingredients, function (i) { return i.IngredientId === autoAddIngredientId; });
                var otherWithSameAutoAdd = _.filter(autoAddIngredient.CanBeAutoAddedFrom || [], function (canBeAutoAddedFromIngredientId) {
                    return model.RecipeItems.some(function (item) { return item.IngredientId === canBeAutoAddedFromIngredientId && ingredient.IngredientId !== canBeAutoAddedFromIngredientId });
                }) || [];
                return otherWithSameAutoAdd.length === 0;
            }) || [];
        var ingredientsToBeRemoved = prerequisiteIngredients.concat(autoAddIngredients);

        ingredientsToBeRemoved.forEach((ingredientId) => {
            Vendd.RecipeLibrary.RemoveIngredient(model, recipeId, ingredientId, null, true, true);
        });
    }

    Vendd.RecipeLibrary.AddRemoveIngredients = function (model, recipeId, addIngredientIds, removeIngredientIds, quantity) {
        var recipe = _recipes[recipeId];

        if (!_recipes[recipeId]) {
            return returnResponse(recipeId, 500, [1000]);
        }

        if (!recipe) {
            return returnResponse(recipeId, 500, [1001]);
        }
        quantity = quantity || 1;

        _.each((addIngredientIds || []), function (ingredientId) {
            var group = null;
            var ingredient = _.find(model.Ingredients, function (i) { return i.IngredientId === ingredientId; });
            if (ingredient) group = _.find(model.Groups, function (g) { return g.Id === ingredient.GroupId; });

            if (!(ingredient && group)) {
                return;
            }
            var recipeIngredient = _.first(_.filter(model.RecipeItems, function (x) { return x.IngredientId === ingredientId && x.RecipeId === recipeId; }));

            var totalIngredientQuantity = quantity;
            var price = (Math.round(ingredient.Price * 100) / 100);
            var priceWithoutVat = (Math.round(ingredient.PriceWithoutVat * 100) / 100);
            if (recipeIngredient) {
                recipeIngredient.Quantity = totalIngredientQuantity;
                recipeIngredient.Price = price;
                recipeIngredient.PriceWithoutVat = priceWithoutVat;
            } else {
                model.RecipeItems.push({
                    RecipeId: recipeId,
                    Category: ingredient.Category,
                    CategoryCode: ingredient.CategoryCode,
                    ManufacturerProductCode: ingredient.ManufacturerProductCode,
                    GroupId: group.Id,
                    IngredientId: ingredient.IngredientId,
                    ProductItemCode: ingredient.RecipeItemCode,
                    ProductItemId: ingredient.RecipeItemId,
                    VariantId: ingredient.VariantId,
                    Name: ingredient.Name || "",
                    Quantity: quantity,
                    Price: price,
                    PriceWithoutVat: priceWithoutVat,
                    TotalPrice: quantity * price,
                    TotalPriceWithoutVat: quantity * priceWithoutVat,
                    Weight: ingredient.Weight,
                    IsStandard: ingredient.DefaultQuantity > 0,
                    IsStandardExcludePackage: ingredient.DefaultQuantity > 0,
                    IsMandatory: ingredient.IsMandatory,
                    OptionType: ingredient.OptionType,
                    SubRecipeId: ingredient.SubRecipeId,
                    SubRecipeCode: ingredient.SubRecipeCode,
                    Attributes: ingredient.Attributes
                });
            }
        });

        _.each((removeIngredientIds || []), function (ingredientId) {
            var group = null;
            var ingredient = _.find(model.Ingredients, function (i) { return i.IngredientId === ingredientId; });
            if (ingredient) group = _.find(model.Groups, function (g) { return g.Id === ingredient.GroupId; });

            if (!(ingredient && group)) {
                return;
            }
            var recipeIngredient = _.find(model.RecipeItems, function (x) { return x.IngredientId === ingredientId && x.RecipeId === recipeId; });

            if (!recipeIngredient) return;

            var totalIngredientQuantity = recipeIngredient.Quantity - quantity;
            var price = (Math.round(ingredient.Price * 100) / 100);
            var priceWithoutVat = (Math.round(ingredient.PriceWithoutVat * 100) / 100);


            if (recipeIngredient && totalIngredientQuantity > 0) {
                recipeIngredient.Quantity = totalIngredientQuantity;
                recipeIngredient.Price = price;
                recipeIngredient.PriceWithoutVat = priceWithoutVat;
            } else {
                model.RecipeItems = _.filter(model.RecipeItems, function (x) { return x.IngredientId !== ingredientId; });
            }
        });

        model.HashCode = getRecipeItemsHashCode(recipeId);

        return Vendd.RecipeLibrary.DeclareState(model, recipeId);
    };

    Vendd.RecipeLibrary.GetFullRecipeItems = function (recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        var recipeItems = recipe.RecipeItems || [];
        _.each(
            _.filter(recipe.Ingredients, function (item) {
                return item.SubRecipeId && (_.find(recipeItems, function (i) { return i.IngredientId === item.IngredientId; }) !== undefined);
            }), function (item) {
                if (!item.IsStandard) {
                    _.each(_recipes[item.RecipeItemId].RecipeItems, function (ingredient) { ingredient.IsStandard = false; });
                }
                recipeItems = recipeItems.concat(_recipes[item.RecipeItemId].RecipeItems);
            });
        var data = {};
        data.RecipeItems = recipeItems || [];
        return returnResponse(recipeId, 200, [], data);
    };

    Vendd.RecipeLibrary.GetRecipeItems = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        var data = {};
        data.RecipeItems = recipe.RecipeItems || [];
        return returnResponse(recipeId, 200, [], data);
    };

    Vendd.RecipeLibrary.GetOneDealerData = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        var data = {};

        data.ManufacturerName = recipe.ManufacturerName || "";
        data.ProductCode = recipe.ManufacturerProductCode || "";
        data.ManufacturerCode = recipe.ManufacturerCode || "";
        data.Series = recipe.CategoryCode || "";
        data.Name = recipe.Name || "";
        data.Guid = localStorage.getItem("globalId_" + recipeId);

        data.Prices = {};
        data.Prices.OptionalTotalPrice = FixJSFloatBug(recipe.Prices.OptionalTotalPriceWithoutVat);
        data.Prices.StandardTotalPrice = FixJSFloatBug(recipe.Prices.StandardTotalPriceWithoutVat);
        data.Prices.InitialPrice = FixJSFloatBug(recipe.Prices.InitialPriceWithoutVat);
        data.Prices.TotalPrice = FixJSFloatBug(recipe.Prices.TotalPriceWithoutVat);

        var domainName = window.location.protocol + "//" + window.location.host;
        var pathName = window.location.pathname;
        var url = domainName + pathName;
        data.Host = {};
        data.Host.Domain = domainName;
        data.Host.Path = pathName;
        data.Host.URL = url;

        data.ModelImageAbsoluteUrl = recipe.ProductImageUrl;

        var cartTypeCode = _.find(recipe.Attributes, function (i) { return i.Code === "CarTypeCode"; }) || {};
        data.CarTypeCode = (cartTypeCode.Value || "Car");
        var fuelTypeCode = _.find(recipe.Attributes, function (i) { return i.Code === (recipe.FuelTypeCodeAttributeCode || "FuelTypeName"); }) || {};
        data.FuelTypeCode = (fuelTypeCode.Value || "");
        var attributes = _.filter(recipe.Attributes, function (i) { return i.Code !== "CarTypeCode" && i.Code !== (recipe.FuelTypeCodeAttributeCode || "FuelTypeName"); }) || [];
        data.Attributes = _.map(attributes, function (i) {
            var item = {};
            item.AttributeCode = i.Code;
            item.Value = i.Value;
            item.Type = i.ValueType;
            return item;
        });
        var recipeItems = recipe.RecipeItems || [];
        _.each(
            _.filter(recipe.Ingredients, function (item) {
                return item.SubRecipeId && (_.find(recipeItems, function (i) { return i.IngredientId === item.IngredientId; }) !== undefined);
            }), function (item) {
                if (!item.IsStandard) {
                    _.each(_recipes[item.RecipeItemId].RecipeItems, function (ingredient) { ingredient.IsStandard = false; ingredient.SubRecipeCode = item.ManufacturerProductCode; });
                }
                recipeItems = recipeItems.concat(_recipes[item.RecipeItemId].RecipeItems);
            });

        data.RecipeItems = _.map(recipeItems || [], function (i) {
            var item = {};
            item.CategoryCode = i.CategoryCode || "";
            item.Name = i.Name;
            item.Quantity = i.Quantity;
            //item.Price = i.Price;
            item.Price = i.TotalPrice === 0 ? 0 : i.PriceWithoutVat;
            item.ItemCode = i.ManufacturerProductCode || "";
            item.IsPackage = (i.SubRecipeId || 0) > 0;
            item.ParentPackageCode = i.IsStandardExcludePackage ? i.SubRecipeCode || "" : "";
            item.OptionType = i.OptionType;
            return item;
        });
        data.WeightMaxCapacity = recipe.WeightMaxCapacity || 0;
        data.WeightRemainingCapacity = recipe.WeightRemainingCapacity || 0;
        data.WeightOptionalEquipmentCapacity = recipe.WeightOptionalEquipmentCapacity || 0;
        data.WeightModelCapacity = recipe.WeightModelCapacity || 0;
        data.WeightTotalCapacity = data.WeightModelCapacity + data.WeightOptionalEquipmentCapacity;

        data.RoadTaxAmount = FixJSFloatBug(recipe.Prices.Tax || 0);
        data.RegistrationFeeAmount = FixJSFloatBug(recipe.Prices.Fee || 0);

        return returnResponse(recipeId, 200, [], data);
    };


    Vendd.RecipeLibrary.InitExternalProductImageData = function (recipeId, uri) {

        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        recipe.ExternalProductImageIsEnabled = true;
        recipe.ExternalProductImageData = recipe.ExternalProductImageData || {};
        recipe.ExternalProductImageData.Parameters = recipe.ExternalProductImageData.Parameters || {
            //source: "omnimto",
            //consumer: "low",
            //market: "1000",
            //brand: "00",
            //model: "3347H",

            //mmvs: "00334S1P7000",
            //wheel: "128",
            //body: "018",
            //seat: "010",

            //opt: "018,010,128,025,40H,416,5BH,850,9Z5,056,097,499,4JA,5QX,NHR,8EW,JAY,RCG,RS9,UGD,5CC,320,4YD,5A5,6HQ,LMC,8FZ,JR1",
            //pack: "",
            //drive: "1",
            //engine: "10",
            //fuel: "2",
            //gear: "43",

            //angle: "1",
            //view: "EXT",
            width: "800",
            height: "600",
            background: "ffffff",
            //raiseError:""

        };
        uri = uri || "";
        uri = uri !== "" && uri.indexOf("http") !== 0 ? window.location.origin + (uri.indexOf("/") !== 0 ? "/" : "") + uri : uri;
        recipe.ExternalProductImageData.Uri = uri;
    }

    Vendd.RecipeLibrary.SetExternalProductImageParameter = function (recipeId, parameter, value) {

        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        recipe.ExternalProductImageData = recipe.ExternalProductImageData || {};
        recipe.ExternalProductImageData.Parameters = recipe.ExternalProductImageData.Parameters || {};

        recipe.ExternalProductImageData.Parameters[parameter] = value;
    }

    Vendd.RecipeLibrary.RefreshExternalProductImageParameters = function (recipeId, type) {

        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        var optItems = _.filter(recipe.RecipeItems || [], function (item) {
            return !(item.Attributes || []).some(function (a) {
                return (
                    (a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.IsWheelAttributeCode.replace("ItemAttributes_", "").toLowerCase() && a.Value) ||
                    (a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.IsBodyAttributeCode.replace("ItemAttributes_", "").toLowerCase() && a.Value) ||
                    (a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.IsSeatAttributeCode.replace("ItemAttributes_", "").toLowerCase() && a.Value)
                );
            }) && (item.Attributes || []).some(function (a) {
                return (a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.DMSCodeAttributeCode.replace("ItemAttributes_", "").toLowerCase() && a.Value !== "");
            });
        }) || [];
        if ((type || "one-dealer") === "one-dealer") {
            recipe.ExternalProductImageData.Parameters["productCode"] = recipe.ManufacturerProductCode || "";
            recipe.ExternalProductImageData.Parameters["opts"] = (_.map(optItems, function (item) { return (_.find(item.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.DMSCodeAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || ""; }) || []).join(',');

        } else if ((type || "one-dealer") === "vendallion") {

            recipe.ExternalProductImageData.Parameters["source"] = (_.find(recipe.Attributes, function (i) { return i.Code.replace("ItemAttributes_", "").toLowerCase() === "sourcecode"; }) || {}).Value || "omnimto";
            recipe.ExternalProductImageData.Parameters["consumer"] = (_.find(recipe.Attributes, function (i) { return i.Code.replace("ItemAttributes_", "").toLowerCase() === "consumercode"; }) || {}).Value || "low";
            recipe.ExternalProductImageData.Parameters["market"] = (_.find(recipe.Attributes, function (i) { return i.Code.replace("ItemAttributes_", "").toLowerCase() === "marketcode"; }) || {}).Value || "1000";
            recipe.ExternalProductImageData.Parameters["brand"] = (_.find(recipe.Attributes, function (i) { return i.Code.replace("ItemAttributes_", "").toLowerCase() === "brandcode"; }) || {}).Value || "00";
            recipe.ExternalProductImageData.Parameters["model"] = (_.find(recipe.Attributes, function (i) { return i.Code.replace("ItemAttributes_", "").toLowerCase() === "modelcode"; }) || {}).Value || "3347H";

            recipe.ExternalProductImageData.Parameters["mmvs"] = (_.find(recipe.Attributes, function (i) { return i.Code.replace("ItemAttributes_", "").toLowerCase() === "mmvscode"; }) || {}).Value || "00334S1P7000";

            recipe.ExternalProductImageData.Parameters["drive"] = (_.find(recipe.Attributes, function (i) { return i.Code.replace("ItemAttributes_", "").toLowerCase() === "drivecode"; }) || {}).Value || "1";
            recipe.ExternalProductImageData.Parameters["engine"] = (_.find(recipe.Attributes, function (i) { return i.Code.replace("ItemAttributes_", "").toLowerCase() === "enginecode"; }) || {}).Value || "10";
            recipe.ExternalProductImageData.Parameters["fuel"] = (_.find(recipe.Attributes, function (i) { return i.Code.replace("ItemAttributes_", "").toLowerCase() === "fuelcode"; }) || {}).Value || "2";
            recipe.ExternalProductImageData.Parameters["gear"] = (_.find(recipe.Attributes, function (i) { return i.Code.replace("ItemAttributes_", "").toLowerCase() === "gearcode"; }) || {}).Value || "43";

            var wheelItem = _.find(recipe.RecipeItems, function (item) {
                return (item.Attributes || []).some(function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.IsWheelAttributeCode.replace("ItemAttributes_", "").toLowerCase() && a.Value; });
            });
            recipe.ExternalProductImageData.Parameters["wheel"] = wheelItem ? (_.find(wheelItem.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.DMSCodeAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || "" : "128";

            var bodyItem = _.find(recipe.RecipeItems, function (item) {
                return (item.Attributes || []).some(function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.IsBodyAttributeCode.replace("ItemAttributes_", "").toLowerCase() && a.Value; });
            });
            recipe.ExternalProductImageData.Parameters["body"] = bodyItem ? (_.find(bodyItem.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.DMSCodeAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || "" : "018";

            var seatItem = _.find(recipe.RecipeItems, function (item) {
                return (item.Attributes || []).some(function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.IsSeatAttributeCode.replace("ItemAttributes_", "").toLowerCase() && a.Value; });
            });
            recipe.ExternalProductImageData.Parameters["seat"] = seatItem ? (_.find(seatItem.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.DMSCodeAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || "" : "010";
            recipe.ExternalProductImageData.Parameters["opt"] = (_.map(optItems, function (item) { return (_.find(item.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.DMSCodeAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || ""; }) || []).join(',');

        } else {
            recipe.ExternalProductImageData.Parameters["opt"] = (_.map(optItems, function (item) { return (_.find(item.Attributes || [], function (a) { return a.Code.replace("ItemAttributes_", "").toLowerCase() === recipe.DMSCodeAttributeCode.replace("ItemAttributes_", "").toLowerCase(); }) || {}).Value || ""; }) || []).join(',');
        }   
    }

    Vendd.RecipeLibrary.GetExternalProductImage = function (recipeId, type) {

        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        Vendd.RecipeLibrary.RefreshExternalProductImageParameters(recipeId, type);

        var parameters = new URLSearchParams(recipe.ExternalProductImageData.Parameters);
        var imageUrl = recipe.ExternalProductImageData.Uri + "?" + parameters.toString();

        return imageUrl;
    }

    Vendd.RecipeLibrary.GetOneDealerResourceView = function (config) {
        var _def = $.Deferred();

        if (!config.RecipeId) {
            return _def.resolve(returnResponse(null, 500, [1061]));
        }
        var recipe = _recipes[config.RecipeId];
        if (!recipe) {
            return _def.resolve(returnResponse(config.RecipeId, 500, [1000]));
        }

        var defaultConfiguration = {
            serviceurl: "/services/api/OneDealer/GetResourceViewAsync"
        };

        defaultConfiguration.onSuccess = function (response) {
            _recipes[config.RecipeId].ExternalProductImageData = _recipes[config.RecipeId].ExternalProductImageData || {};
            _recipes[config.RecipeId].ExternalProductImageData.Views = response.data;

            return _def.resolve(returnResponse(config.RecipeId, 200, [], response.data));
        };
        defaultConfiguration.onError = function (response) {
            return _def.reject(returnResponse(config.RecipeId, 500, [1060], response));
        };

        config = $.extend({}, defaultConfiguration, config || {});

        taxAndFeeRequest = $.ajax({
            type: "POST",
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            url: config.serviceurl,
            async: true,
            data: JSON.stringify({ "productCode": recipe.ManufacturerProductCode }),
            error: config.onError,
            success: function (response) {
                if (!response.success || !response.data) {
                    return config.onError(response);
                }
                return config.onSuccess(response);
            }
        });

        return _def.promise();
    };

    Vendd.RecipeLibrary.SetRecipeItems = function (recipeId, recipeItems) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        recipe.RecipeItems = recipeItems || [];

        return Vendd.RecipeLibrary.DeclareState(recipe, recipeId);
    };

    Vendd.RecipeLibrary.GetCheckedRecipeItems = function (recipeId, forceOptional) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        forceOptional = forceOptional !== undefined ? forceOptional : false;
        //var checkedItems = _.filter(recipe.Ingredients, function (item) { return item.DefaultQuantity > 0; });

        //var checkedRecipeItems = _.filter(recipe.RecipeItems, function (item) { return item.Quantity > 0; });

        var checkedRecipeItems = [];
        var optionalTotalPrice = 0;
        var optionalTotalItems = 0;
        var standardTotalPrice = 0;
        var standardTotalItems = 0;
        var optionalTotalPriceWithoutVat = 0;
        var standardTotalPriceWithoutVat = 0;

        //var deafaultItems = _.filter(recipe.Ingredients, function (item) { return item.DefaultQuantity > 0; });
        $.each(recipe.Ingredients, function (indexInArray, ingredient) {
            var item = _.find(recipe.RecipeItems, function (i) { return i.IngredientId === ingredient.IngredientId && i.Quantity > 0; });
            var groupQuantity = getGroupQuantity(recipe, { Id: ingredient.GroupId }, ingredient.IngredientId);
            var isMultiSelect = (_.find(recipe.Groups, function (group) { return ingredient.GroupId === group.Id; }) || {}).IsMultiSelect;
            var isChecked = item;
            if (!isMultiSelect) {
                var selectedItems = _.filter(recipe.RecipeItems, function (i) { return i.GroupId === ingredient.GroupId; }) || [];
                if (selectedItems.length > 1) {
                    isChecked = isChecked && (selectedItems[0].IngredientId === ingredient.IngredientId);
                }
            }
            var isStandard = forceOptional ? false : (ingredient.IsNullable ? false : ingredient.DefaultQuantity > 0);
            if (isChecked) {
                var price = Math.round(ingredient.Price * 100) / 100;
                var totalPrice = ingredient.DefaultQuantity > 0 ?
                    ((item.Quantity || 0) - (ingredient.DefaultQuantity || 0)) * price :
                    (item.Quantity || 0) * price;
                var priceWithoutVat = Math.round(ingredient.PriceWithoutVat * 100) / 100;
                var totalPriceWithoutVat = ingredient.DefaultQuantity > 0 ?
                    ((item.Quantity || 0) - (ingredient.DefaultQuantity || 0)) * priceWithoutVat :
                    (item.Quantity || 0) * priceWithoutVat;
                checkedRecipeItems.push({
                    RecipeItemId: recipeId,
                    ImageUrl: ingredient.ImageUrl,
                    Category: ingredient.Category,
                    GroupId: ingredient.GroupId,
                    IngredientId: ingredient.IngredientId,
                    ProductItemId: ingredient.RecipeItemId,
                    VariantId: ingredient.VariantId,
                    Name: ingredient.Name || "",
                    //ParentProductId: recipeId,
                    ManufacturerProductCode: ingredient.ManufacturerProductCode,
                    DMSCode: ingredient.DMSCode,
                    Quantity: item.Quantity,
                    Price: price,
                    PriceWithoutVat: priceWithoutVat,
                    TotalPriceWithoutVat: totalPriceWithoutVat,
                    TotalPrice: totalPrice,
                    Weight: ingredient.Weight,
                    GrossWeight: ingredient.GrossWeight,
                    IsStandardExcludePackage: ingredient.DefaultQuantity > 0,
                    IsStandard: isStandard,
                    IsMandatory: ingredient.IsMandatory,
                    OptionType: ingredient.OptionType
                });
                if (isStandard) {
                    standardTotalPrice += totalPrice;
                    standardTotalPriceWithoutVat += totalPriceWithoutVat;
                    standardTotalItems++;
                } else {
                    optionalTotalPrice += totalPrice;
                    optionalTotalPriceWithoutVat += totalPriceWithoutVat;
                    optionalTotalItems++;
                }
            }
            if (ingredient.IsNullable) {
                if (groupQuantity === 0) {
                    checkedRecipeItems.push({
                        RecipeItemId: recipeId,
                        ImageUrl: ingredient.ImageUrl,
                        Category: ingredient.Category,
                        GroupId: ingredient.GroupId,
                        IngredientId: ingredient.IngredientId,
                        ProductItemId: ingredient.RecipeItemId,
                        VariantId: ingredient.VariantId,
                        Name: ingredient.Name || "",
                        //ParentProductId: recipeId,
                        Quantity: 1,
                        Price: 0,
                        PriceWithoutVat: 0,
                        TotalPrice: 0,
                        TotalPriceWithoutVat: 0,
                        Weight: 0,
                        GrossWeight: 0,
                        IsStandardExcludePackage: ingredient.DefaultQuantity > 0,
                        IsStandard: isStandard,
                        IsMandatory: ingredient.IsMandatory,
                        OptionType: ingredient.OptionType
                    });
                }
            }

            if (item && (item.Quantity || 0) > 0 && ingredient.SubRecipe) {
                var subCheckedRecipeItems = Vendd.RecipeLibrary.GetCheckedRecipeItems(ingredient.RecipeItemId, !isStandard) || {};
                if (subCheckedRecipeItems.success) {
                    item.TotalPrice = subCheckedRecipeItems.data.Prices.TotalPrice;
                    item.TotalPriceWithoutVat = subCheckedRecipeItems.data.Prices.TotalPriceWithoutVat;
                    checkedRecipeItems = (checkedRecipeItems || []).concat(subCheckedRecipeItems.data.CheckedRecipeItems || []);
                    //checkedRecipeItems = _.extend([], checkedRecipeItems, subCheckedRecipeItems.data.CheckedRecipeItems);
                }
            }
        });

        var uncheckedRecipeItems = _.reject(recipe.Ingredients, function (item) { return _.find(checkedRecipeItems, function (checked) { return item.IngredientId === checked.IngredientId; }); });

        var data = {};
        data.CheckedItemsOptionalTotal = optionalTotalItems;
        data.CheckedItemsStandardTotal = standardTotalItems;
        data.CheckedRecipeItems = checkedRecipeItems;
        data.UncheckedRecipeItems = uncheckedRecipeItems;
        data.Prices = {};
        data.Prices.OptionalTotalPrice = optionalTotalPrice;
        data.Prices.OptionalTotalPriceWithoutVat = optionalTotalPriceWithoutVat;
        data.Prices.StandardTotalPrice = standardTotalPrice;
        data.Prices.StandardTotalPriceWithoutVat = standardTotalPriceWithoutVat;
        data.Prices.InitialPrice = recipe.UnitPrice;
        data.Prices.InitialPriceWithoutVat = recipe.UnitPriceWithoutVat;
        data.Prices.TotalAddonsPrice = recipe.AddonsPrice || 0;
        data.Prices.TotalAddonsPriceWithoutVat = recipe.AddonsPriceWithoutVat || 0;

        data.Prices.Fee = (recipe.Prices || {}).Fee || 0;
        data.Prices.Tax = (recipe.Prices || {}).Tax || 0;

        data.Prices.TotalPrice = data.Prices.TotalAddonsPrice + optionalTotalPrice + standardTotalPrice + recipe.UnitPrice;
        data.Prices.TotalPriceWithoutVat = data.Prices.TotalAddonsPriceWithoutVat + optionalTotalPriceWithoutVat + standardTotalPriceWithoutVat + recipe.UnitPriceWithoutVat;

        recipe.Prices = data.Prices;

        return returnResponse(recipeId, 200, [], data);

    };

    Vendd.RecipeLibrary.GetPrices = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        var prices = {};
        prices.OptionalTotalPrice = 0;
        prices.StandardTotalPrice = 0;
        prices.OptionalTotalPriceWithoutVat = 0;
        prices.StandardTotalPriceWithoutVat = 0;
        _.each(recipe.RecipeItems, function (ri) {
            var ingredient = _.find(recipe.Ingredients, function (i) { return i.IngredientId === ri.IngredientId; }) || {};
            var defaultQuantity = ingredient.DefaultQuantity || 0;
            var initialPrice = Math.round((ingredient.Price || 0) * 100) / 100;
            var initialPriceWithoutVat = Math.round((ingredient.PriceWithoutVat || 0) * 100) / 100;
            var optionalQuantity = Math.max(ri.Quantity - defaultQuantity);
            var optionalTotalPrice = initialPrice * optionalQuantity;
            var optionalTotalPriceWithoutVat = initialPriceWithoutVat * optionalQuantity;
            var standardTotalPrice = 0;//defaultQuantity > 0 ? initialPrice * defaultQuantity : 0;
            var standardTotalPriceWithoutVat = 0;//defaultQuantity > 0 ? initialPrice * defaultQuantity : 0;
            if (ingredient.SubRecipe && ri.Quantity > 0) {
                var subPrices = Vendd.RecipeLibrary.GetPrices(ingredient.RecipeItemId) || {};
                optionalTotalPrice += (subPrices.OptionalTotalPrice || 0);
                optionalTotalPriceWithoutVat += (subPrices.OptionalTotalPriceWithoutVat || 0);
                standardTotalPrice += (subPrices.StandardTotalPrice || 0);
                standardTotalPriceWithoutVat += (subPrices.StandardTotalPriceWithoutVat || 0);
            }
            prices.OptionalTotalPrice += optionalTotalPrice;
            prices.StandardTotalPrice += standardTotalPrice;
            prices.OptionalTotalPriceWithoutVat += optionalTotalPriceWithoutVat;
            prices.StandardTotalPriceWithoutVat += standardTotalPriceWithoutVat;
        });
        prices.InitialPrice = recipe.UnitPrice;
        prices.InitialPriceWithoutVat = recipe.UnitPriceWithoutVat;
        
        prices.TotalAddonsPrice = _.reduce(recipe.Addons, function (memo, item) { return memo + (item.Price || 0); }, 0);
        prices.TotalAddonsPriceWithoutVat = _.reduce(recipe.Addons, function (memo, item) { return memo + (item.PriceWithoutVat || 0); }, 0);

        prices.Fee = recipe.Prices.Fee || 0;
        prices.Tax = recipe.Prices.Tax || 0;

        prices.VATAmount = (prices.TotalAddonsPrice + prices.OptionalTotalPrice + prices.StandardTotalPrice + prices.InitialPrice) - (prices.TotalAddonsPriceWithoutVat + prices.OptionalTotalPriceWithoutVat + prices.StandardTotalPriceWithoutVat + prices.InitialPriceWithoutVat);

        prices.TotalPrice = prices.TotalAddonsPrice + prices.OptionalTotalPrice + prices.StandardTotalPrice + prices.InitialPrice;
        prices.TotalPriceWithoutVat = prices.TotalAddonsPriceWithoutVat + prices.OptionalTotalPriceWithoutVat + prices.StandardTotalPriceWithoutVat + prices.InitialPriceWithoutVat;
        recipe.Prices = prices;
        return prices;
    };

    Vendd.RecipeLibrary.GetWeight = function (recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        var weightObj = {};
        weightObj.InitialWeight = recipe.Weight || 0;
        weightObj.OptionalTotalWeight = getTotalWeight(recipe, recipeId);
        return weightObj;

    };

    Vendd.RecipeLibrary.SetWeight = function (recipeId, WeightMaxCapacity) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        var weightObj = {};
        recipe.WeightMaxCapacity = WeightMaxCapacity;
        recipe.WeightModelCapacity = recipe.Weight || 0;
        recipe.WeightOptionalEquipmentCapacity = getTotalWeight(recipe, recipeId);
        recipe.WeightRemainingCapacity = parseInt(WeightMaxCapacity || 0) - (recipe.WeightModelCapacity + recipe.WeightOptionalEquipmentCapacity);
    };

    Vendd.RecipeLibrary.GetGrossWeight = function (recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        var weightObj = {};
        weightObj.InitialGrossWeight = recipe.GrossWeight || 0;
        weightObj.OptionalTotalGrossWeight = getTotalGrossWeight(recipe, recipeId);
        weightObj.TotalGrossWeight = weightObj.InitialGrossWeight + weightObj.OptionalTotalGrossWeight;
        return weightObj;

    };

    Vendd.RecipeLibrary.GetCo2 = function (recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        var obj = {};
        obj.InitialCo2 = recipe.Co2 || 0;
        obj.OptionalTotalCo2 = getTotalIngredientsCo2(recipe, recipeId);
        obj.AddonsTotalCo2 = getTotalAddonsCo2(recipe, recipeId);
        obj.TotalCo2 = obj.InitialCo2 + obj.OptionalTotalCo2 + obj.AddonsTotalCo2;
        return obj;
    };

    Vendd.RecipeLibrary.SetCo2Attribute = function (code) {
        recipe.Co2AttributeCode = code;
    };

    Vendd.RecipeLibrary.GetTaxAndFeeRequestData = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        var data = {};
        data.co2 = (Vendd.RecipeLibrary.GetCo2(recipeId) || {}).TotalCo2 || 0;
        data.engineDisplacement = recipe.EngineDisplacement;
        data.fuelType = recipe.FuelTypeCode;
        data.makeCode = recipe.ManufacturerProductCode;
        data.vehiclePrice = recipe.Prices.TotalPriceWithoutVat;
        data.vehicleTypeCode = recipe.VehicleTypeCode || "";
        data.bodyStyleCode = recipe.BodyStyleCode || "";
        data.grossWeight = (Vendd.RecipeLibrary.GetGrossWeight(recipeId) || {}).TotalGrossWeight || 0;
        data.numberOfSeats = recipe.NumberOfSeats;

        //data.co2 = 10 * recipe.RecipeItems.length;
        //data.engineDisplacement = 100;
        //data.fuelType = "1";
        //data.makeCode = recipe.ManufacturerProductCode;
        //data.vehiclePrice = recipe.Prices.TotalPriceWithoutVat;

        return returnResponse(recipeId, 200, [], data);
    };

    var cacheTaxAndFee = {};    
    var taxAndFeeRequest = null;
    Vendd.RecipeLibrary.GetTaxAndFee = function (config) {
        var _def = $.Deferred();

        if (!config.RecipeId) {
            return _def.resolve(returnResponse(null, 500, [1061]));
        }
        var recipe = _recipes[config.RecipeId];
        if (!recipe) {
            return _def.resolve(returnResponse(config.RecipeId, 500, [1000]));
        }
        var data = {};
        var cacheKey;

        var defaultConfiguration = {
            serviceurl: "/services/api/OneDealer/GetVehicleFeeAndTaxAsync"
        };

        defaultConfiguration.onSuccess = function (response) {
            _recipes[config.RecipeId].Prices.Fee = response.data.Fee;
            _recipes[config.RecipeId].Prices.Tax = response.data.Tax;

            return _def.resolve(returnResponse(config.RecipeId, 200, [], data));
        };
        defaultConfiguration.onError = function (response) {
            return _def.reject(returnResponse(config.RecipeId, 500, [1060], response));
        };

        config = $.extend({}, defaultConfiguration, config || {});


        var requestData = Vendd.RecipeLibrary.GetTaxAndFeeRequestData(config.RecipeId);
        if (!requestData.success || !requestData.data) {
            return config.onError(response);
        }
        cacheKey = JSON.stringify(requestData.data);
        if (cacheTaxAndFee.hasOwnProperty(cacheKey)) {
            _recipes[config.RecipeId].Prices.Fee = cacheTaxAndFee[cacheKey].Fee;
            _recipes[config.RecipeId].Prices.Tax = cacheTaxAndFee[cacheKey].Tax;
            return _def.resolve(returnResponse(config.RecipeId, 200, [], cacheTaxAndFee[cacheKey]));
            if (taxAndFeeRequest !== null) {
                taxAndFeeRequest.abort();
                taxAndFeeRequest = null;
            }
            return _def.resolve(returnResponse(config.RecipeId, 200, 0, cacheTaxAndFee[cacheKey]));
            
        }
        if (taxAndFeeRequest !== null) {
            taxAndFeeRequest.abort();
            taxAndFeeRequest = null;
        }
        taxAndFeeRequest = $.ajax({
            type: "POST",
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            url: config.serviceurl,
            async: true,
            data: cacheKey,
            error: config.onError,
            success: function (response) {
                if (!response.success || !response.data) {
                    return config.onError(response);
                }
                cacheTaxAndFee[cacheKey] = response.data;
                return config.onSuccess(response);
            }
        });

        return _def.promise();
    };

    Vendd.RecipeLibrary.GetEnabledItems = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        var data = {};
        data.EnabledItems = [];
        data.DisableItems = [];

        data.GroupErrors = [];

        data.Errors = [];

        var totalQuantity = getTotalQuantity(recipe);
        var extraQuantity = 0;
        var errorCode = 0;
        if (totalQuantity < recipe.MinQuantity) {
            errorCode = 1042;
            extraQuantity = recipe.MinQuantity - totalQuantity;
        }
        else if (totalQuantity > recipe.MaxQuantity) {
            errorCode = 1043;
            extraQuantity = totalQuantity - recipe.MaxQuantity;
        }
        if (errorCode > 0) {
            data.Errors.push({
                RecipeId: recipeId,
                ErrorCode: errorCode,
                ErrorCodes: [errorCode],
                ExtraQuantity: extraQuantity,
                MinQuantity: recipe.MinQuantity,
                MaxQuantity: recipe.MaxQuantity,
                Quantity: totalQuantity
            });
        }

        $.each(recipe.Categories, function (indexCategory, category) {
            $.each(category.Groups, function (indexGroup, group) {
                var groupQuantity = getGroupQuantity(recipe, group);
                var disableAllGroup = _.filter(recipe.Ingredients, function (i) { return i.GroupId === group.Id && !i.CanRemove && !group.IsMultiSelect; }).length > 0;
                $.each(group.VisualGroups, function (indexVisualGroup, visualGroup) {
                    $.each(visualGroup.Items, function (indexItem, ingredient) {
                        var recipeIngredient = _.first(_.filter(recipe.RecipeItems, function (x) { return x.IngredientId === ingredient.IngredientId && x.RecipeId === recipeId; })) || {};
                        var quantity = recipeIngredient.Quantity || 0;
                        //einai project specific gia bjt, prepei na allaxei se general
                        var isDisableFromSubRecipe = false; //subRecipeIngredientIds.some(function (x) { return x == ingredient.IngredientId; });
                        var isDisabled = !ingredient.CanRemove ||
                            (ingredient.MaxQuantity <= quantity && ingredient.MinQuantity > quantity) ||
                            //(group.MinQuantity >= groupQuantity && quantity > 0) ||
                            (group.MaxQuantity <= groupQuantity && quantity === 0) ||
                            //(recipe.MinQuantity >= totalQuantity && quantity > 0) ||
                            (recipe.MaxQuantity <= totalQuantity && quantity === 0)
                            ;
                        var canAdd = ingredient.MaxQuantity > quantity && group.MaxQuantity > groupQuantity;
                        var canRemove = ingredient.MinQuantity < quantity && ingredient.CanRemove;
                        var isChecked = quantity > 0;
                        var checkIncompatibles = (Vendd.RecipeLibrary.CheckIncompatibles(recipeId, ingredient.IngredientId));
                        var isEnabledIncompatible = checkIncompatibles.success || (!checkIncompatibles.success && checkIncompatibles.data.BothSelected);
                        var checkPrerequisites = (Vendd.RecipeLibrary.CheckPrerequisites(recipeId, ingredient.IngredientId));
                        var isEnabledPrerequisites = checkPrerequisites.success || (!checkPrerequisites.success && checkPrerequisites.data.BothPrerequisite);
                        var checkPrerequisitesAnyOfSet = (Vendd.RecipeLibrary.CheckPrerequisitesAnyOfSet(recipeId, ingredient.IngredientId));
                        var isEnabledPrerequisitesAnyOfSet = checkPrerequisitesAnyOfSet.success || (!checkPrerequisitesAnyOfSet.success && checkPrerequisitesAnyOfSet.data.BothPrerequisite);
                        var errorCodes = [];
                        if (!disableAllGroup && ((!group.IsMultiSelect || !isDisabled) && (isEnabledIncompatible && isEnabledPrerequisites && isEnabledPrerequisitesAnyOfSet && !isDisableFromSubRecipe && !ingredient.IsAutoAddIngredient) || ingredient.IsNullable)) {
                            if (isDisabled && ingredient.DefaultQuantity > 0 && ingredient.MinQuantity === ingredient.DefaultQuantity) errorCodes.push(1012);
                            if (!checkIncompatibles.success)
                                errorCodes = errorCodes.concat(checkIncompatibles.status.ErrorCodes);
                            if (!checkPrerequisites.success)
                                errorCodes = errorCodes.concat(checkPrerequisites.status.ErrorCodes);
                            if (!checkPrerequisitesAnyOfSet.success)
                                errorCodes = errorCodes.concat(checkPrerequisitesAnyOfSet.status.ErrorCodes);
                            data.EnabledItems.push({
                                IsEnabled: true,
                                RecipeId: recipeId,
                                GroupId: group.Id,
                                IngredientId: ingredient.IngredientId,
                                ProductItemId: ingredient.RecipeItemId,
                                VariantId: ingredient.VariantId,
                                ErrorCodes: errorCodes,
                                CanAdd: canAdd,
                                canRemove: canRemove,
                                Incompatibles: checkIncompatibles.data.Incompatibles,
                                MissingPrerequisites: checkPrerequisites.data.MissingPrerequisites,
                                MissingAnyOfPrerequisites: checkPrerequisitesAnyOfSet.data.MissingAnyOfPrerequisites,
                                AutoAdd: ingredient.AutoAdd,
                                DepedenciesIngredientsOnAdd: { "Add": [], "Remove": [] }
                            });
                        } else {
                            if (ingredient.IsAutoAddIngredient) errorCodes.push(1036);
                            if (isDisabled && ingredient.DefaultQuantity > 0 && ingredient.MinQuantity === ingredient.DefaultQuantity) errorCodes.push(1012);
                            if (group.MaxQuantity <= groupQuantity && group.IsMultiSelect && !isChecked) errorCodes.push(1021);
                            if (disableAllGroup) errorCodes.push(1021);
                            if (recipe.MaxQuantity <= totalQuantity && group.IsMultiSelect && !isChecked) errorCodes.push(1041);
                            if (ingredient.MinQuantity > quantity && group.IsMultiSelect && isChecked) errorCodes.push(1010);
                            if (ingredient.MaxQuantity <= quantity && group.IsMultiSelect && !isChecked) errorCodes.push(1011);
                            if (!checkIncompatibles.success) errorCodes.push(1030);
                            if (!checkPrerequisites.success) errorCodes.push(1031);
                            if (!checkPrerequisitesAnyOfSet.success) errorCodes.push(1033);
                            if (isDisableFromSubRecipe) errorCodes.push(1034);
                            if (errorCodes.length > 0) {
                                data.DisableItems.push({
                                    IsEnabled: false,
                                    RecipeId: recipeId,
                                    GroupId: group.Id,
                                    IngredientId: ingredient.IngredientId,
                                    ProductItemId: ingredient.RecipeItemId,
                                    VariantId: ingredient.VariantId,
                                    ErrorCodes: errorCodes,
                                    CanAdd: canAdd,
                                    canRemove: canRemove,
                                    Incompatibles: checkIncompatibles.data.Incompatibles,
                                    MissingPrerequisites: checkPrerequisites.data.MissingPrerequisites,
                                    MissingAnyOfPrerequisites: checkPrerequisitesAnyOfSet.data.MissingAnyOfPrerequisites,
                                    AutoAdd: ingredient.AutoAdd,
                                    DepedenciesIngredientsOnAdd: []
                                });
                            }
                        }
                    });
                });
                var groupErrorCode = 0;
                var extraQuantity = 0;
                if (groupQuantity < group.MinQuantity) {
                    groupErrorCode = 1022;
                    extraQuantity = group.MinQuantity - groupQuantity;
                }
                else if (groupQuantity > group.MaxQuantity) {
                    groupErrorCode = 1023;
                    extraQuantity = groupQuantity - group.MaxQuantity;
                }
                if (groupErrorCode > 0) {
                    data.GroupErrors.push({
                        Id: group.Id,
                        RecipeId: recipeId,
                        ErrorCodes: [groupErrorCode],
                        ExtraQuantity: extraQuantity,
                        MinQuantity: group.MinQuantity,
                        MaxQuantity: group.MaxQuantity,
                        Quantity: groupQuantity,
                        Name: group.Name,
                        CategoryName: category.Category
                    });
                }
            });
        });

        return returnResponse(recipeId, 200, [], data);
    };

    function uuidv4() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    Vendd.RecipeLibrary.GetDependencies = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        return returnResponse(recipeId, 200, [], recipe.Dependencies);
    };

    Vendd.RecipeLibrary.GetIngedientByIngredientId = function (recipeId, ingredientId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        if (!ingredientId) {
            return returnResponse(recipeId, 500, [1000]);
        }

        var ingredient = _.find(recipe.Ingredients, function (item) { return item.IngredientId === ingredientId });

        if (!ingredient) {
            return returnResponse(recipeId, 500, [1000]);
        }

        return returnResponse(recipeId, 200, [], ingredient);
    };


    Vendd.RecipeLibrary.SetDependencies = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        var ingredients = _.clone(recipe.Ingredients);

        ingredients.forEach((ingredient) => {
            //if (ingredient.IngredientId === 365554)
            {
                var rootIngredientIsChecked = recipe.RecipeItems.some(function (r) { return r.IngredientId === ingredient.IngredientId; });
                ingredient.DepedenciesIngredientsOnAdd = ((Vendd.RecipeLibrary.GetPrerequisiteDependenciesIngredients(recipeId, ingredient.IngredientId, ingredient.IngredientId, null, 0, rootIngredientIsChecked) || {}).data || []);
                ingredient.Checked = rootIngredientIsChecked;
            }
        });

        ingredients.forEach((ingredient) => {
            (ingredient.DepedenciesIngredientsOnAdd || []).forEach((dependency) => {
                dependency.IsValid = true;
                dependency.ErrorCodes = [];
                var sameItems = _.filter((dependency.Add || []), function (a) { return dependency.Remove.some(function (r) { return a.IngredientId === r.IngredientId; }) });
                if (sameItems.length > 0) {
                    dependency.IsValid = false;
                    dependency.ErrorCodes.push(
                        {
                            "ErrorCode": 1080,
                            "Items": sameItems,
                            "Title": (Vendd.RecipeLibrary.Literals["error1080"] || "")
                        }
                    );
                }
                var sameSingGroupItems = _.filter((dependency.Add || []), function (a) {
                    return dependency.Add.some(function (r) {
                        return a.IngredientId !== r.IngredientId && a.GroupId === r.GroupId && !a.IsGroupMultiSelect;
                    })
                });
                if (sameSingGroupItems.length > 0) {
                    dependency.IsValid = false;
                    dependency.ErrorCodes.push(
                        {
                            "ErrorCode": 1081,
                            "Items": sameSingGroupItems,
                            "Title": (Vendd.RecipeLibrary.Literals["error1081"] || "")
                        }
                    );
                }
                var mandatoryItems = _.filter((dependency.Remove || []), function (r) {
                    return r.IsMandatory;
                });
                if (mandatoryItems.length > 0) {
                    dependency.IsValid = false;
                    dependency.ErrorCodes.push(
                        {
                            "ErrorCode": 1082,
                            "Items": mandatoryItems,
                            "Title": (Vendd.RecipeLibrary.Literals["error1082"] || "")
                        });
                }
                dependency.IsVisible = dependency.Add.length > 0 || dependency.Remove.length > 0;
                dependency.Price = (_.reduce(dependency.Add, function (memo, item) { return memo + (item.Price || 0); }, 0)) - (_.reduce(dependency.Remove, function (memo, item) { return memo + (item.Price || 0); }, 0));
                dependency.PriceWithoutVat = (_.reduce(dependency.Add, function (memo, item) { return memo + (item.PriceWithoutVat || 0); }, 0)) - (_.reduce(dependency.Remove, function (memo, item) { return memo + (item.PriceWithoutVat || 0); }, 0));
            });
            ingredient.HasDependencies = !ingredient.IsAutoAddIngredient && (ingredient.DepedenciesIngredientsOnAdd || []).some(function (x) { return x.IsVisible; });
        });

        recipe.Dependencies = ingredients;

        return returnResponse(recipeId, 200, [], ingredients);
    };

    var debugDebendenciesRootIngredientId;
    var debugDebendenciesIngredientId;
    var debugDebendencies;
    Vendd.RecipeLibrary.SetdDebugDebendencies = function (rootIngredientId, ingredientId) {
        debugDebendenciesRootIngredientId = rootIngredientId;
        debugDebendenciesIngredientId = ingredientId;
        debugDebendencies = !!debugDebendenciesRootIngredientId || !!debugDebendenciesIngredientId;
    }

    Vendd.RecipeLibrary.GetPrerequisiteDependenciesIngredients = function (recipeId, rootIngredientId, ingredientId, lists, depth, rootIngredientIsChecked, IsAdded) {

        var recipe = _recipes[recipeId];

        if (!recipe || !ingredientId || !rootIngredientId) {
            return returnResponse(recipeId, 500, [1000]);
        }
        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
            console.log("-----------------------");
            console.log("Lists:", lists);
            console.log("Depth:", depth);
            console.log("Ingredient Id:", ingredientId);
        }

        var ingredients = _.clone(recipe.Ingredients);

        var ingredient = _.find(ingredients, function (item) { return item.IngredientId === ingredientId });

        if (!ingredient) {
            return returnResponse(recipeId, 200, [], _lists);
        }

        IsAdded = IsAdded !== false;

        depth++;
        if (depth === 10) {
            console.log("Maximum depth succeeded for ingredient: ", rootIngredientId);
            return returnResponse(recipeId, 200, [], lists);
        }
   
        var _lists = _.clone(lists ||
            [
                {
                    "IngredientId": rootIngredientId,
                    "Add": [],
                    "Remove": [],
                    "guid" : uuidv4()
                }
            ]);

        if (!rootIngredientIsChecked && IsAdded) {
            (ingredient.RequiresAnyOfSet || []).forEach((set) => {
                var infectedLists = _.clone(_.filter(_lists, function (l) { return depth === 1 || l.Add.some(function (a) { return a.IngredientId === ingredientId }); }));
                infectedLists.forEach((list) => {
                    var _tmpList = _.clone(list);
                    var exist = set.RequiresAnyOfItems.some(function (i) {
                        return _tmpList.Add.some(function (l) { return l.IngredientId === i; }) ||
                            recipe.RecipeItems.some(function (r) { return r.IngredientId === i; }) ||
                            i === ingredientId ||
                            i === rootIngredientId;
                    });
                    if (exist) return;
                    //ADD rule to check if set has any requireanyofitem allready in recipeitems or add list
                    set.RequiresAnyOfItems.forEach((prerequisite) => {
                        if (recipe.RecipeItems.some(function (r) { return r.IngredientId === prerequisite; })) return;
                        var _list = {
                            "IngredientId": _tmpList.IngredientId,
                            "Add": _.clone(_tmpList.Add),
                            "SetIngredientId": prerequisite,
                            "Remove": _.clone(_tmpList.Remove),
                            "guid": uuidv4()
                        };
                        var _ingredient = _.find(ingredients, function (item) { return item.IngredientId === prerequisite });
                        var itemInfo = {
                            "Price": _ingredient.Price,
                            "PriceText": _ingredient.PriceText,
                            "PriceWithoutVat": _ingredient.PriceWithoutVat,
                            "PriceWithoutVatText": _ingredient.PriceWithoutVatText,
                            "Category": _ingredient.Category,
                            "Name": _ingredient.Name,
                            "DMSCode": _ingredient.DMSCode,
                            "Description": _ingredient.Description,
                            "ExtendedDescription": _ingredient.ExtendedDescription,
                            "ImageUrl": _ingredient.ImageUrl,
                            "IngredientId": _ingredient.IngredientId,
                            "IsAutoAddIngredient": _ingredient.IsAutoAddIngredient,
                            "IsVisible": _ingredient.IsVisible,
                            "GroupId": _ingredient.GroupId,
                            "IsMandatory": _ingredient.IsMandatory,
                            "IsGroupMultiSelect": _ingredient.IsGroupMultiSelect
                        };
                        _list.Add.push(itemInfo);

                        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                            console.log(`--${ingredient.DMSCode} => Requires Any Of Set Add => ${_ingredient.DMSCode}--`);
                            console.log("_lists:", _lists);
                        }

                        _lists = _lists.concat((Vendd.RecipeLibrary.GetPrerequisiteDependenciesIngredients(recipeId, rootIngredientId, prerequisite, [_list], depth, rootIngredientIsChecked, true) || {}).data || []);
                        _lists = _.reject(_lists, function (l) { return l.guid === _tmpList.guid; });

                        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                            console.log("--Requires Any Of Set Reject--");
                            console.log("_lists:", _lists);
                        }
                        //}
                    });
                });
            });

            //check required/auto add => Add to selected list
            var allPrerequisites = _.filter(ingredient.Prerequisites, function (x) { return !recipe.RecipeItems.some(function (r) { return r.IngredientId === x; }); });
            var autoAdd = _.filter(ingredient.AutoAdd, function (x) { return !recipe.RecipeItems.some(function (r) { return r.IngredientId === x; }); });
            allPrerequisites = allPrerequisites.concat(autoAdd);

            allPrerequisites.forEach((prerequisite) => {
                var infectedLists = (_.filter(_lists, function (l) { return depth === 1 || l.Add.some(function (a) { return a.IngredientId === ingredientId }); }));
                infectedLists.forEach((list) => {
                    if (!list.Add.some(function (l) { return l.IngredientId === prerequisite; }) && prerequisite !== rootIngredientId) {
                        //console.log("Prerequisite:", prerequisite);
                        var _ingredient = _.find(ingredients, function (item) { return item.IngredientId === prerequisite });
                        var itemInfo = {
                            "Price": _ingredient.Price,
                            "PriceText": _ingredient.PriceText,
                            "PriceWithoutVat": _ingredient.PriceWithoutVat,
                            "PriceWithoutVatText": _ingredient.PriceWithoutVatText,
                            "Category": _ingredient.Category,
                            "Name": _ingredient.Name,
                            "DMSCode": _ingredient.DMSCode,
                            "Description": _ingredient.Description,
                            "ExtendedDescription": _ingredient.ExtendedDescription,
                            "ImageUrl": _ingredient.ImageUrl,
                            "IngredientId": _ingredient.IngredientId,
                            "IsAutoAddIngredient": _ingredient.IsAutoAddIngredient,
                            "IsVisible": _ingredient.IsVisible,
                            "GroupId": _ingredient.GroupId,
                            "IsMandatory": _ingredient.IsMandatory,
                            "IsGroupMultiSelect": _ingredient.IsGroupMultiSelect
                        };
                        list.Add.push(itemInfo);

                        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                            console.log(`--${ingredient.DMSCode} => Requires => ${_ingredient.DMSCode}--`);
                            console.log("list:", list);
                            console.log("_lists:", _lists);
                        }

                        _lists = (Vendd.RecipeLibrary.GetPrerequisiteDependenciesIngredients(recipeId, rootIngredientId, prerequisite, _lists, depth, rootIngredientIsChecked, true) || {}).data || [];

                        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                            console.log("--Requires end--");
                            console.log("list:", list);
                            console.log("_lists:", _lists);
                        }
                    }
                });
            });
        }


        if (IsAdded) {
            //check incompatibles => remove selected list
            var incompatibles = _.filter((ingredient.Incompatibles || []), function (x) { return recipe.RecipeItems.some(function (r) { return r.IngredientId === x; }); });
            incompatibles.forEach((incompatible) => {
                var infectedLists = (_.filter(_lists, function (l) { return depth === 1 || l.Add.some(function (a) { return a.IngredientId === ingredientId }); }));
                infectedLists.forEach((list) => {
                    if (!list.Remove.some(function (l) { return l.IngredientId === incompatible; }) && rootIngredientId !== incompatible) {
                        var _ingredient = _.find(ingredients, function (item) { return item.IngredientId === incompatible });
                        var itemInfo = {
                            "Price": _ingredient.Price,
                            "PriceText": _ingredient.PriceText,
                            "PriceWithoutVat": _ingredient.PriceWithoutVat,
                            "PriceWithoutVatText": _ingredient.PriceWithoutVatText,
                            "Category": _ingredient.Category,
                            "Name": _ingredient.Name,
                            "DMSCode": _ingredient.DMSCode,
                            "Description": _ingredient.Description,
                            "ExtendedDescription": _ingredient.ExtendedDescription,
                            "ImageUrl": _ingredient.ImageUrl,
                            "IngredientId": _ingredient.IngredientId,
                            "IsAutoAddIngredient": _ingredient.IsAutoAddIngredient,
                            "IsVisible": _ingredient.IsVisible,
                            "GroupId": _ingredient.GroupId,
                            "IsMandatory": _ingredient.IsMandatory,
                            "IsGroupMultiSelect": _ingredient.IsGroupMultiSelect
                        };
                        list.Remove.push(itemInfo);

                        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                            console.log(`--${ingredient.DMSCode} => Incompatible => ${_ingredient.DMSCode}--`);
                            console.log("list:", list);
                            console.log("_lists:", _lists);
                        }

                        _lists = (Vendd.RecipeLibrary.GetPrerequisiteDependenciesIngredients(recipeId, rootIngredientId, incompatible, _lists, depth, rootIngredientIsChecked, false) || {}).data || [];

                        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                            console.log("--incompatible end--");
                            console.log("list:", list);
                            console.log("_lists:", _lists);
                        }
                    }
                });
            });

            //check remove => Selected Single group
            if (!ingredient.IsGroupMultiSelect) {
                var removeLists = (_.filter(_lists, function (l) { return depth === 1 || l.Add.some(function (a) { return a.IngredientId === ingredientId }); }));
                removeLists.forEach((list) => {
                    var incompatible = (_.find(recipe.RecipeItems, function (x) { return x.GroupId === ingredient.GroupId && x.RecipeId === recipeId; }) || {}).IngredientId;
                    if (!incompatible) return;
                    if (!list.Remove.some(function (l) { return l.IngredientId === incompatible; }) && rootIngredientId !== incompatible) {
                        var _ingredient = _.find(ingredients, function (item) { return item.IngredientId === incompatible });
                        var itemInfo = {
                            "Price": _ingredient.Price,
                            "PriceText": _ingredient.PriceText,
                            "PriceWithoutVat": _ingredient.PriceWithoutVat,
                            "PriceWithoutVatText": _ingredient.PriceWithoutVatText,
                            "Category": _ingredient.Category,
                            "Name": _ingredient.Name,
                            "DMSCode": _ingredient.DMSCode,
                            "Description": _ingredient.Description,
                            "ExtendedDescription": _ingredient.ExtendedDescription,
                            "ImageUrl": _ingredient.ImageUrl,
                            "IngredientId": _ingredient.IngredientId,
                            "IsAutoAddIngredient": _ingredient.IsAutoAddIngredient,
                            "IsVisible": _ingredient.IsVisible,
                            "GroupId": _ingredient.GroupId,
                            "IsMandatory": _ingredient.IsMandatory,
                            "IsGroupMultiSelect": _ingredient.IsGroupMultiSelect
                        };
                        list.Remove.push(itemInfo);

                        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                            console.log(`--${ingredient.DMSCode} => Is Same Single Group with => ${_ingredient.DMSCode} and must be removed--`);
                            console.log("list:", list);
                            console.log("_lists:", _lists);
                        }

                        _lists = (Vendd.RecipeLibrary.GetPrerequisiteDependenciesIngredients(recipeId, rootIngredientId, incompatible, _lists, depth, rootIngredientIsChecked, false) || {}).data || [];

                        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                            console.log("--remove single group end--");
                            console.log("list:", list);
                            console.log("_lists:", _lists);
                        }
                    }
                });
            }
        }


        if (!IsAdded) {
            //check remove => required by
            var removeLists = (_.filter(_lists, function (l) { return depth === 1 || l.Remove.some(function (a) { return a.IngredientId === ingredientId }); }));
            removeLists.forEach((list) => {
                var incompatibles = _.filter((ingredient.IsRequiredBy || []), function (x) { return recipe.RecipeItems.some(function (r) { return r.IngredientId === x; }); });

                incompatibles.forEach((incompatible) => {

                    if (!list.Remove.some(function (l) { return l.IngredientId === incompatible; }) && rootIngredientId !== incompatible) {
                        var _ingredient = _.find(ingredients, function (item) { return item.IngredientId === incompatible });
                        var itemInfo = {
                            "Price": _ingredient.Price,
                            "PriceText": _ingredient.PriceText,
                            "PriceWithoutVat": _ingredient.PriceWithoutVat,
                            "PriceWithoutVatText": _ingredient.PriceWithoutVatText,
                            "Category": _ingredient.Category,
                            "Name": _ingredient.Name,
                            "DMSCode": _ingredient.DMSCode,
                            "Description": _ingredient.Description,
                            "ExtendedDescription": _ingredient.ExtendedDescription,
                            "ImageUrl": _ingredient.ImageUrl,
                            "IngredientId": _ingredient.IngredientId,
                            "IsAutoAddIngredient": _ingredient.IsAutoAddIngredient,
                            "IsVisible": _ingredient.IsVisible,
                            "GroupId": _ingredient.GroupId,
                            "IsMandatory": _ingredient.IsMandatory,
                            "IsGroupMultiSelect": _ingredient.IsGroupMultiSelect
                        };
                        list.Remove.push(itemInfo);

                        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                            console.log(`--${ingredient.DMSCode} has been removed => is required by => ${_ingredient.DMSCode} and must be removed--`);
                            console.log("list:", list);
                            console.log("_lists:", _lists);
                        }

                        _lists = (Vendd.RecipeLibrary.GetPrerequisiteDependenciesIngredients(recipeId, rootIngredientId, incompatible, _lists, depth, rootIngredientIsChecked, false) || {}).data || [];

                        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                            console.log("--remove -> required by end--");
                            console.log("list:", list);
                            console.log("_lists:", _lists);
                        }
                    }
                });
            });
        }

        if (!IsAdded) {
            //check Remove => require by any of set
            //var removeLists = (_.filter(_lists, function (l) { return depth === 1 || l.Remove.some(function (a) { a === ingredientId }); }));
            removeLists.forEach((list) => {
                var incompatibles = [];
                _.each((ingredient.IsRequiredByAnyOfSet || []), function (x) {
                    var _ingredient = _.find(ingredients, function (item) { return item.IngredientId === x.IsRequiredByAnyOfSetItem });
                    if (!_ingredient) return;
                    var _set = _.find(_ingredient.RequiresAnyOfSet, function (s) { return s.SetId === x.SetId });
                    if (!_set) return;
                    var anyOtherOfSetIsSelcted = _set.RequiresAnyOfItems.some(
                        function (s) {
                            return (recipe.RecipeItems.some(function (r) {
                                return r.IngredientId === s && r.IngredientId !== _ingredient.IngredientId;
                            })) || ((list.Add || []).some(function (l) {
                                return l.IngredientId === s && l.IngredientId !== _ingredient.IngredientId;
                            }));
                        });
                    if (!anyOtherOfSetIsSelcted) incompatibles.push(_ingredient.IngredientId);
                });

                incompatibles.forEach((incompatible) => {

                    if (!list.Remove.some(function (l) { return l.IngredientId === incompatible; }) && rootIngredientId !== incompatible) {
                        var _ingredient = _.find(ingredients, function (item) { return item.IngredientId === incompatible });
                        var itemInfo = {
                            "Price": _ingredient.Price,
                            "PriceText": _ingredient.PriceText,
                            "PriceWithoutVat": _ingredient.PriceWithoutVat,
                            "PriceWithoutVatText": _ingredient.PriceWithoutVatText,
                            "Category": _ingredient.Category,
                            "Name": _ingredient.Name,
                            "DMSCode": _ingredient.DMSCode,
                            "Description": _ingredient.Description,
                            "ExtendedDescription": _ingredient.ExtendedDescription,
                            "ImageUrl": _ingredient.ImageUrl,
                            "IngredientId": _ingredient.IngredientId,
                            "IsAutoAddIngredient": _ingredient.IsAutoAddIngredient,
                            "IsVisible": _ingredient.IsVisible,
                            "GroupId": _ingredient.GroupId,
                            "IsMandatory": _ingredient.IsMandatory,
                            "IsGroupMultiSelect": _ingredient.IsGroupMultiSelect
                        };
                        list.Remove.push(itemInfo);

                        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                            console.log(`--${ingredient.DMSCode} has been removed => is required by any of set => ${_ingredient.DMSCode} and must be removed--`);
                            console.log("list:", list);
                            console.log("_lists:", _lists);
                        }

                        _lists = (Vendd.RecipeLibrary.GetPrerequisiteDependenciesIngredients(recipeId, rootIngredientId, incompatible, _lists, depth, rootIngredientIsChecked, false) || {}).data || [];

                        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                            console.log("--remove -> required by any of set end--");
                            console.log("list:", list);
                            console.log("_lists:", _lists);
                        }
                    }
                });
            });
        }

        //add -> remove from Single group must add one of other
        if (!rootIngredientIsChecked && !ingredient.IsGroupMultiSelect && !IsAdded) {
            var infectedLists = _.clone(_.filter(_lists, function (l) { return l.Remove.some(function (a) { return a.IngredientId === ingredientId }); }));
            infectedLists.forEach((list) => {
                var _tmpList = _.clone(list);
                var exist = ingredient.SingleGroupIngredients.some(function (i) {
                    return _tmpList.Add.some(function (l) { return l.IngredientId === i; }) || i === rootIngredientId;
                });
                if (exist) return;
                //console.log("rootIngredientId", rootIngredientId);
                //console.log("ingredientId", ingredientId);
                //console.log("groupItems", ingredient.SingleGroupIngredients);
                //console.log("_tmpList", _tmpList);
                ingredient.SingleGroupIngredients.forEach((gi) => {
                    if (recipe.RecipeItems.some(function (r) { return r.IngredientId === gi; })) return;
                    var _list = {
                        "IngredientId": _tmpList.IngredientId,
                        "Add": _.clone(_tmpList.Add),
                        "GrouItemId": gi,
                        "Remove": _.clone(_tmpList.Remove),
                        "guid": uuidv4()
                    };
                    var _ingredient = _.find(ingredients, function (item) { return item.IngredientId === gi });
                    var itemInfo = {
                        "Price": _ingredient.Price,
                        "PriceText": _ingredient.PriceText,
                        "PriceWithoutVat": _ingredient.PriceWithoutVat,
                        "PriceWithoutVatText": _ingredient.PriceWithoutVatText,
                        "Category": _ingredient.Category,
                        "Name": _ingredient.Name,
                        "DMSCode": _ingredient.DMSCode,
                        "Description": _ingredient.Description,
                        "ExtendedDescription": _ingredient.ExtendedDescription,
                        "ImageUrl": _ingredient.ImageUrl,
                        "IngredientId": _ingredient.IngredientId,
                        "IsAutoAddIngredient": _ingredient.IsAutoAddIngredient,
                        "IsVisible": _ingredient.IsVisible,
                        "GroupId": _ingredient.GroupId,
                        "IsMandatory": _ingredient.IsMandatory,
                        "IsGroupMultiSelect": _ingredient.IsGroupMultiSelect
                    };
                    _list.Add.push(itemInfo);

                    if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                        console.log(`--${ingredient.DMSCode} has been removed => add other from single group => ${_ingredient.DMSCode} --`);
                        console.log("_lists:", _lists);
                    }

                    _lists = _lists.concat((Vendd.RecipeLibrary.GetPrerequisiteDependenciesIngredients(recipeId, rootIngredientId, gi, [_list], depth, rootIngredientIsChecked, true) || {}).data || []);
                    _lists = _.reject(_lists, function (l) { return l.guid === _tmpList.guid; });

                    if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
                        console.log("--Requires Any Of Set Reject--");
                        console.log("_lists:", _lists);
                    }
                });
            });
        }

        if (debugDebendencies && rootIngredientId === debugDebendenciesRootIngredientId) {
            console.log("--END--");
            console.log("Lists:", _lists);
            console.log("Depth:", depth);
            console.log("Ingredient Id:", ingredientId);
        }

        return returnResponse(recipeId, 200, [], _lists);

    }

    Vendd.RecipeLibrary.CheckIncompatibles = function (recipeId, ingredientId) {

        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        var ingredient = _.find(recipe.Ingredients, function (i) { return i.IngredientId === ingredientId; });
        var recipeIngredient = _.first(_.filter(recipe.RecipeItems, function (x) { return x.IngredientId === ingredient.IngredientId; })) || {};

        if (!ingredient) {
            return returnResponse(recipeId, 500, [1002]);
        }

        var data = {};
        var incompatibles = _.filter(ingredient.Incompatibles,
            function (i) {
                return recipe.RecipeItems.some(function (item) {
                    var isSameSingleSelectGroup = item.GroupId === ingredient.GroupId && recipe.Groups.some(function (g) { return g.Id === item.GroupId && !g.IsMultiSelect });
                    return item.IngredientId === i && !isSameSingleSelectGroup;
                });
            }) || [];

        if (incompatibles.length > 0) {
            data.Incompatibles = _.filter(recipe.Ingredients, function (item) { return incompatibles.some(function (i) { return item.IngredientId === i; }) });
            data.BothSelected = (recipeIngredient.Quantity || 0) > 0;
            return returnResponse(recipeId, 500, [1030], data);
        }

        return returnResponse(recipeId, 200);
    }

    Vendd.RecipeLibrary.CheckPrerequisites = function (recipeId, ingredientId) {

        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        var ingredient = _.find(recipe.Ingredients, function (i) { return i.IngredientId === ingredientId });

        if (!ingredient) {
            return returnResponse(recipeId, 500, [1002]);
        }

        var data = {};
        var missingPrerequisites = _.filter(ingredient.Prerequisites,
            function (i) {
                return !recipe.RecipeItems.some(function (item) { return item.IngredientId === i; });
            }) || [];

        if (missingPrerequisites.length > 0) {
            data.MissingPrerequisites = _.filter(recipe.Ingredients, function (item) { return missingPrerequisites.some(function (i) { return item.IngredientId === i; }) });
            var bothPrerequisite = _.filter(data.MissingPrerequisites,
                function (i) {
                    return (i.Prerequisites.length > 0 && i.Prerequisites.some(function (item) { return item === ingredient.IngredientId; })) ||
                        (
                            i.RequiresAnyOfSet.length > 0 &&
                            i.RequiresAnyOfSet.some(function (set) {
                                return set.RequiresAnyOfItems.length > 0 && set.RequiresAnyOfItems.some(function (setItem) {
                                    return setItem === ingredient.IngredientId;
                                });
                            })
                        );
                }) || [];

            data.BothPrerequisite = bothPrerequisite.length > 0;
            return returnResponse(recipeId, 500, [1031], data);
        }

        return returnResponse(recipeId, 200);
    }

    Vendd.RecipeLibrary.CheckPrerequisitesAnyOfSet = function (recipeId, ingredientId) {

        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        var ingredient = _.find(recipe.Ingredients, function (i) { return i.IngredientId === ingredientId });

        if (!ingredient) {
            return returnResponse(recipeId, 500, [1002]);
        }

        var data = {};
        data.MissingAnyOfPrerequisites = [];
        var hasMissingAnyOfPrerequisites = false;
        for (var i = 0; i < (ingredient.RequiresAnyOfSet || []).length; i++) {
            var requiredSetItems = ingredient.RequiresAnyOfSet[i].RequiresAnyOfItems || [];
            var anyOfIngredient = _.filter(requiredSetItems,
                function (i) {
                    return recipe.RecipeItems.some(function (item) { return item.IngredientId === i; });
                }) || [];

            if (anyOfIngredient.length === 0 && requiredSetItems.length > 0) {
                hasMissingAnyOfPrerequisites = true;
                var missingAnyOfPrerequisites = _.filter(recipe.Ingredients, function (item) { return requiredSetItems.some(function (i) { return item.IngredientId === i; }); });
                data.MissingAnyOfPrerequisites.push(missingAnyOfPrerequisites);
                data.BothPrerequisite = missingAnyOfPrerequisites.some(function (item) { return item.Prerequisites.some(function (i) { return i == ingredientId }); });
            }
        }
        if (hasMissingAnyOfPrerequisites)
            return returnResponse(recipeId, 500, [1033], data);

        return returnResponse(recipeId, 200);
    }

    Vendd.RecipeLibrary.IsValid = function (recipeId) {

        var recipe = _recipes[recipeId];
        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        var data = {};
        data.Errors = [];
        data.GroupErrors = [];
        data.IngredientsErrors = [];

        var totalQuantity = getTotalQuantity(recipe, recipeId);
        var extraQuantity = 0;
        var errorCode = 0;
        if (totalQuantity < recipe.MinQuantity) {
            errorCode = 1042;
            extraQuantity = recipe.MinQuantity - totalQuantity;
        }
        else if (totalQuantity > recipe.MaxQuantity) {
            errorCode = 1043;
            extraQuantity = totalQuantity - recipe.MaxQuantity;
        }
        if (errorCode > 0) {
            data.Errors.push({
                ParentProductId: recipeId,
                ErrorCodes: [errorCode],
                ExtraQuantity: extraQuantity,
                MinQuantity: recipe.MinQuantity,
                MaxQuantity: recipe.MaxQuantity,
                Quantity: totalQuantity
            });
        }

        $.each(recipe.Categories, function (indexCategory, category) {
            $.each(category.Groups, function (indexGroup, group) {
                var groupErrorCode = 0;
                var extraQuantity = 0;
                var groupQuantity = getGroupQuantity(recipe, group);
                if (groupQuantity < group.MinQuantity) {
                    groupErrorCode = 1022;
                    extraQuantity = group.MinQuantity - groupQuantity;
                }
                else if (groupQuantity > group.MaxQuantity) {
                    groupErrorCode = 1023;
                    extraQuantity = groupQuantity - group.MaxQuantity;
                }
                if (groupErrorCode > 0) {
                    data.GroupErrors.push({
                        Id: group.Id,
                        RecipeId: recipeId,
                        ErrorCodes: [groupErrorCode],
                        ExtraQuantity: extraQuantity,
                        MinQuantity: group.MinQuantity,
                        MaxQuantity: group.MaxQuantity,
                        Quantity: groupQuantity,
                        Name: group.Name,
                        CategoryName: category.Category
                    });
                }
                $.each(group.VisualGroups, function (indexVisualGroup, visualGroup) {
                    $.each(visualGroup.Items, function (indexItem, ingredient) {
                        var recipeIngredient = _.first(_.filter(recipe.RecipeItems, function (x) { return x.IngredientId === ingredient.IngredientId; })) || _.find(recipe.RecipeItems, function (i) { return ingredient.RecipeItemId === i.RecipeItemId; }) || {};
                        var quantity = recipeIngredient.Quantity || 0;
                        var checkIncompatibles = (Vendd.RecipeLibrary.CheckIncompatibles(recipeId, ingredient.IngredientId));
                        var checkPrerequisites = (Vendd.RecipeLibrary.CheckPrerequisites(recipeId, ingredient.IngredientId));
                        var checkPrerequisitesAnyOfSet = (Vendd.RecipeLibrary.CheckPrerequisitesAnyOfSet(recipeId, ingredient.IngredientId));
                        var errorCodes = [];
                        if (ingredient.MinQuantity > quantity) errorCodes.push(1010);
                        if (ingredient.MaxQuantity < quantity) errorCodes.push(1011);
                        if (!checkIncompatibles.success && quantity > 0) errorCodes.push(1030);
                        if (!checkPrerequisites.success && quantity > 0) errorCodes.push(1031);
                        if (!checkPrerequisitesAnyOfSet.success && quantity > 0) errorCodes.push(1033);
                        if (errorCodes.length > 0) {
                            data.IngredientsErrors.push({
                                RecipeId: recipeId,
                                GroupId: group.Id,
                                IngredientId: ingredient.IngredientId,
                                ErrorCodes: errorCodes,
                                Incompatibles: checkIncompatibles.data.Incompatibles || [],
                                MissingPrerequisites: checkPrerequisites.data.MissingPrerequisites || [],
                                MissingAnyOfPrerequisites: checkPrerequisitesAnyOfSet.data.MissingAnyOfPrerequisites || [],
                                Name: ingredient.Name || "",
                                Price: ingredient.Price,
                                PriceWithoutVat: ingredient.PriceWithoutVat,
                                PriceText: ingredient.PriceText,
                                PriceWithoutVatText: ingredient.PriceWithoutVatText,
                                TotalPrice: ingredient.TotalPrice,
                                TotalPriceWithoutVat: ingredient.TotalPriceWithoutVat

                            });
                        }
                    });
                });
            });
        });
        data.IsValid = data.Errors.length === 0 && data.GroupErrors.length === 0 && data.IngredientsErrors.length === 0;
        return data;
    }

    Vendd.RecipeLibrary.CompareModels = function (recipeId, savedModel) {

        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        //ingredients hash code
        var ingedientsSavedModel = _.sortBy(savedModel.Ingredients, function (i) { return i.IngredientId; });
        var ingedientTemplate = "{0}_{1}_{2}_{3}_{4}_{5}";
        var ingedientsSavedModelHashCode = _.map(ingedientsSavedModel,
            function (i) {
                return ingedientTemplate
                    .replace("{0}", i.IngredientId || "")
                    .replace("{1}", i.GroupId || "")
                    .replace("{2}", i.Price || "")
                    .replace("{3}", (i.Incompatibles || []).join(","))
                    .replace("{4}", (i.Prerequisites || []).join(","))
                    .replace("{5}", i.PriceWithoutVat === undefined ? "" : i.PriceWithoutVat) // old configuration do not contain PriceWithoutVat in saved json;
            }).join("|");
        var ingedientsModel = _.sortBy(recipe.Ingredients, function (i) { return i.IngredientId; });
        var ingedientsModelHashCode = _.map(ingedientsModel,
            function (i) {
                return ingedientTemplate
                    .replace("{0}", i.IngredientId || "")
                    .replace("{1}", i.GroupId || "")
                    .replace("{2}", i.Price || "")
                    .replace("{3}", (i.Incompatibles || []).join(","))
                    .replace("{4}", (i.Prerequisites || []).join(","))
                    .replace("{5}", i.PriceWithoutVat === undefined ? "" : i.PriceWithoutVat); // old configuration do not contain PriceWithoutVat in saved json;
            }).join("|");

        //groups hash code
        var groupTemplate = "{0}_{1}";
        var groupsSavedModel = _.sortBy(savedModel.Groups, function (i) { return i.Id; });
        var savedGroupsModelHashCode = _.map(groupsSavedModel,
            function (i) {
                return groupTemplate
                    .replace("{0}", i.MinQuantity || 0)
                    .replace("{1}", i.MaxQuantity || 0);
            }).join("|");
        var groupsModel = _.sortBy(recipe.Groups, function (i) { return i.Id; });
        var groupsModelHashCode = _.map(groupsModel,
            function (i) {
                return groupTemplate
                    .replace("{0}", i.MinQuantity || 0)
                    .replace("{1}", i.MaxQuantity || 0);
            }).join("|");

        //models hash code
        var modelTemplate = "{0}_{1}_{2}_{3}";
        var savedModelHashCode = modelTemplate
            .replace("{0}", savedModel.MinQuantity || 0)
            .replace("{1}", savedModel.MaxQuantity || 0)
            .replace("{2}", savedModel.MaxFreeQuantity || 0)
            .replace("{3}", savedModel.MaxReplaceQuantity || 0);
        var modelHashCode = modelTemplate
            .replace("{0}", recipe.MinQuantity || 0)
            .replace("{1}", recipe.MaxQuantity || 0)
            .replace("{2}", recipe.MaxFreeQuantity || 0)
            .replace("{3}", recipe.MaxReplaceQuantity || 0);

        //modelHashCode = ""; //<----remove this , is test data and only
        if (ingedientsSavedModelHashCode === ingedientsModelHashCode && groupsModelHashCode === savedGroupsModelHashCode && savedModelHashCode === modelHashCode)
            return returnResponse(recipeId, [200]);

        var recipeItems = [];
        var IngredientsErrors = [];
        var IngredientsWarnings = [];
        var data = {};
        _.each(savedModel.RecipeItems, function (r) {
            var ingredient = _.find(recipe.Ingredients, function (i) { return r.IngredientId === i.IngredientId; }) || _.find(recipe.Ingredients, function (i) { return r.ProductItemId === i.RecipeItemId; }) || null;
            var savedIngredient = _.find(savedModel.Ingredients, function (i) { return r.IngredientId === i.IngredientId; }) || _.find(savedModel.Ingredients, function (i) { return r.RecipeItemId === i.RecipeItemId; });
            if (ingredient === null) {
                IngredientsErrors.push({
                    IngredientId: savedIngredient.IngredientId,
                    Name: savedIngredient.Name,
                    Price: savedIngredient.Price,
                    Incompatibles: savedIngredient.Incompatibles,
                    Prerequisites: savedIngredient.Prerequisites,
                    ErrorCodes: [1072]
                });
                return;
            }
            if (ingredient !== null && ingredient.Price !== savedIngredient.Price) {
                IngredientsWarnings.push({
                    IngredientId: savedIngredient.IngredientId,
                    Name: savedIngredient.Name,
                    Price: savedIngredient.Price,
                    Incompatibles: savedIngredient.Incompatibles,
                    Prerequisites: savedIngredient.Prerequisites,
                    ErrorCodes: [1073]
                });
            }
            recipeItems.push({
                RecipeId: recipeId,
                Category: ingredient.Category,
                CategoryCode: ingredient.CategoryCode,
                ManufacturerProductCode: ingredient.ManufacturerProductCode,
                GroupId: ingredient.GroupId,
                IngredientId: ingredient.IngredientId,
                ProductItemCode: ingredient.RecipeItemCode,
                ProductItemId: ingredient.RecipeItemId,
                VariantId: ingredient.VariantId,
                Name: ingredient.Name || "",
                Quantity: (savedIngredient.Quantity || 1),
                Price: savedIngredient.Price,
                PriceWithoutVat: savedIngredient.PriceWithoutVat === undefined ? ingredient.PriceWithoutVat : savedIngredient.PriceWithoutVat,
                TotalPrice: Math.max((savedIngredient.Quantity || 1) - ingredient.DefaultQuantity, 0) * savedIngredient.Price,
                Weight: ingredient.Weight,
                GrossWeight: ingredient.GrossWeight,
                IsStandardExcludePackage: ingredient.DefaultQuantity > 0,
                IsStandard: ingredient.DefaultQuantity > 0,
                IsMandatory: ingredient.IsMandatory,
                OptionType: ingredient.OptionType,
                SubRecipeId: ingredient.SubRecipeId,
                SubRecipeCode: ingredient.SubRecipeCode
            });
        });

        var checkModel = $.extend({}, recipe);
        recipe.RecipeItems = _.reject(recipeItems, function (r) { return IngredientsErrors.some(function (i) { return i.IngredientId === r.IngredientId; }); });

        var validatedModel = Vendd.RecipeLibrary.IsValid(recipeId);

        data.IngredientsErrors = validatedModel.IngredientsErrors.concat(IngredientsErrors);
        data.IngredientsWarnings = IngredientsWarnings;

        data = $.extend({}, validatedModel, data || {});
        if (!data.IsValid || data.IngredientsErrors.length > 0 || data.GroupErrors.length > 0 || data.Errors.length > 0) {
            return returnResponse(recipeId, 500, [1004], data);
        }
        return returnResponse(recipeId, 200);
    }
    /*
     * GET GLOBAL ID CONFIGURATION
     * RecipeId         the receipe identifier
     * Force            if true, although that mighth be cached global id , it will create a new one - default value:false,
     * FriendlyName     a friendly name for saving - default value: empty,
     * Vin              the vin number - default value: empty,
     * PartnerId        the vin number - default value: empty,
     * serviceurl       the url service - default value: '/services/api/Product/SaveRecipeConfiguration',
     * onSuccess        the function of success saving global identifier,
     * onError          the function of error saving global identifier,
     */
    Vendd.RecipeLibrary.GenerateGlobalId = function (config) {

        var _def = $.Deferred();
        var data = {};

        var defaultConfiguration = {
            Force: false,
            FriendlyName: "",
            Vin: "",
            PartnerId: "",
            serviceurl: "/services/api/Product/SaveRecipeConfiguration"
        };

        defaultConfiguration.onSuccess = function (response) {
            if (!response.success || !response.data || !response.data.GlobalId) {
                config.onError(response);
                return;
            }
            data.GlobalId = response.data.GlobalId;
            data.SavedGlobalIdToLocal = (Vendd.RecipeLibrary.SaveGlobalIdToLocal(config.RecipeId, data.GlobalId)).success;
            data.SaveRecipeItemsToLocal = (Vendd.RecipeLibrary.SaveRecipeItemsToLocal(config.RecipeId, data.GlobalId)).success;
            data.HashCode = getRecipeItemsHashCode(config.RecipeId, recipe.RecipeItems);
            _recipes[config.RecipeId].HashCode = data.HashCode;
            _def.resolve(returnResponse(config.RecipeId, 200, [], data));
        };
        defaultConfiguration.onError = function (response) {
            _def.reject(returnResponse(config.RecipeId, 500, [1060], response));
        };

        config = $.extend({}, defaultConfiguration, config || {});

        if (!config.RecipeId) {
            _def.resolve(returnResponse(null, 500, [1061]));
            return;
        }
        var recipe = _recipes[config.RecipeId];
        if (!recipe) {
            _def.resolve(returnResponse(config.RecipeId, 500, [1000]));
            return;
        }

        var currentHashCode = getRecipeItemsHashCode(config.RecipeId);
        var savedHashCode = Vendd.RecipeLibrary.GetLocalStorageRecipeItemsHashCode(config.RecipeId);
        config.HtmlData.Body = "";

        if (!config.Force && localStorage.getItem("globalId_" + config.RecipeId) !== null && currentHashCode === savedHashCode) {
            data.GlobalId = localStorage.getItem("globalId_" + config.RecipeId);
            data.HashCode = currentHashCode;
            _recipes[config.RecipeId].HashCode = currentHashCode;
            _def.resolve(returnResponse(config.RecipeId, 200, [], data));
        } else {
            var jsonData = (Vendd.RecipeLibrary.ConvertToSavedModel(config.RecipeId) || {}).data || {};
            var requestData = JSON.stringify({
                FriendlyName: config.FriendlyName,
                ConfigurationJson: JSON.stringify(jsonData),
                ProductItemId: config.RecipeId,
                ProductIdentifier: config.Vin,
                PartnerId: config.PartnerId !== "" ? config.PartnerId : null,
                Url: window.location.href,
                HtmlData: config.HtmlData,
                IsShare: !config.Force
            });
            $.ajax({
                type: "POST",
                dataType: 'json',
                contentType: 'application/json; charset=UTF-8',
                url: config.serviceurl,
                async: true,
                data: requestData,
                error: config.onError,
                success: config.onSuccess
            });
        }

        return _def.promise();
    };

    Vendd.RecipeLibrary.AssignConfigurationToUser = function (config) {

        var _def = $.Deferred();
        var data = {};

        var defaultConfiguration = {
            serviceurl: "/services/api/Product/SaveRecipeConfiguration"
        };

        defaultConfiguration.onSuccess = function (response) {
            if (!response.success) {
                config.onError(response);
                return;
            }
            _def.resolve(returnResponse(config.RecipeId, 200, [], data));
        };
        defaultConfiguration.onError = function (response) {
            _def.reject(returnResponse(config.RecipeId, 500, [1060], response));
        };

        config = $.extend({}, defaultConfiguration, config || {});

        var requestData = JSON.stringify({
            GlobalId: config.GlobalId || "",
            FriendlyName: "Update User",
            ConfigurationJson: JSON.stringify({}),
            ProductItemId: config.RecipeItemId,
            Url: window.location.href,
        });
        $.ajax({
            type: "POST",
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            url: config.serviceurl,
            async: true,
            data: requestData,
            error: config.onError,
            success: config.onSuccess
        });

        return _def.promise();
    };

    Vendd.RecipeLibrary.LoadFromGlobalId = function (config) {
        var _def = $.Deferred();
        var data = {};

        var defaultConfiguration = {
            serviceurl: "/services/api/Product/GetRecipeConfiguration"
        };

        defaultConfiguration.onSuccess = function (response) {
            if (!response.success || !response.data || !response.data.GlobalId) {
                config.onError(data);
                return;
            }
            data = JSON.parse(response.data.ConfigurationJson || "{}");
            data.GlobalId = response.data.GlobalId;
            data.HtmlData = JSON.parse(response.data.Html || "{}");
            data.Pdf = response.data.Pdf || "";
            data.IsValid = true;
            data.Errors = [];
            data.GroupErrors = [];
            data.IngredientsErrors = [];
            data.IngredientsWarnings = [];

            recipe.RecipeItems = data.RecipeItems;
            recipe.Addons = data.Addons;           

            var compareResult = Vendd.RecipeLibrary.CompareModels(config.RecipeId, data);
            var subrecipeCompareResults = _.map(data.SubRecipes || [], function (subrecipeData) {
                subrecipeData.RecipeItemId = subrecipeData.RecipeItemId || (_.find(_recipes, function (r) { return r.RecipeId === subrecipeData.RecipeId; }) || {}).ProductItemId;
                Vendd.RecipeLibrary.SetRecipeItems(subrecipeData.RecipeItemId, subrecipeData.RecipeItems);
                return Vendd.RecipeLibrary.CompareModels(subrecipeData.RecipeItemId, subrecipeData);
            });
            //console.log("compareResult:", compareResult);
            if (!compareResult.success || subrecipeCompareResults.some(function (r) { return !r.success; })) {
                recipe.IsValid = false;
                recipe.IngredientsErrors = compareResult.data.IngredientsErrors;
                recipe.IngredientsWarnings = compareResult.data.IngredientsWarnings;
                recipe.Errors = compareResult.data.Errors;
                recipe.GroupErrors = compareResult.data.GroupErrors;
                recipe.GlobalId = response.data.GlobalId;
                //data.RecipeItems = recipe.RecipeItems;
                _def.resolve(returnResponse(config.RecipeId, 200, [1070], recipe));
                return;
            }

            recipe.GlobalId = data.GlobalId;
            recipe.Pdf = data.Pdf;
            recipe.IsValid = data.IsValid;
            recipe.Errors = data.Errors;
            recipe.IngredientsErrors = data.IngredientsErrors;
            recipe.IngredientsWarnings = data.IngredientsWarnings;

            _def.resolve(returnResponse(config.RecipeId, 200, [], recipe));
            return;
        };
        defaultConfiguration.onError = function (data) {
            _def.reject(returnResponse(config.RecipeId, 500, [1070], data));
            return;
        };

        config = $.extend({}, defaultConfiguration, config || {});

        var recipe = _recipes[config.RecipeId];
        if (!recipe) {
            _def.resolve(returnResponse(config.RecipeId, 500, [1000]));
            return;
        }

        if ((config.GlobalId || 0) === 0) {
            _def.resolve(returnResponse(config.RecipeId, 500, [1071]));
            return;
        }

        var requestData = JSON.stringify({
            GlobalId: config.GlobalId
        });
        $.ajax({
            type: "POST",
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            url: config.serviceurl,
            async: true,
            data: requestData,
            error: config.onError,
            success: config.onSuccess
        });

        return _def.promise();
    };

    Vendd.RecipeLibrary.SaveGlobalIdToLocal = function (recipeId, globalId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }

        localStorage.setItem("globalId_" + recipeId, globalId);

        return returnResponse(recipeId, 200);
    };

    Vendd.RecipeLibrary.SaveRecipeItemsToLocal = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        var recipeItemsData = Vendd.RecipeLibrary.GetFullRecipeItems(recipeId);
        var recipeItems = recipeItemsData.RecipeItems;
        var currentHashCode = getRecipeItemsHashCode(recipeId, recipeItems);
        var savedHashCode = Vendd.RecipeLibrary.GetLocalStorageRecipeItemsHashCode(recipeId);
        if (currentHashCode === savedHashCode) {
            return returnResponse(recipeId, 200);
        }

        var dataLocalStorage = {
            RecipeItems: recipe.RecipeItems,
            HashCode: currentHashCode
        };

        localStorage.setItem("configurator_" + recipeId, JSON.stringify(dataLocalStorage, null, 2));

        return returnResponse(recipeId, 200);
    };

    Vendd.RecipeLibrary.LoadFromLocalRecipeItems = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        if (localStorage.getItem("configurator_" + recipeId) === null) {
            return returnResponse(recipeId, 500, [1050]);
        }
        //var savedData = $.cookie("model_recipe_" + recipeId) || [];
        var dataLocalStorage = JSON.parse(localStorage.getItem("configurator_" + recipeId) || "{}");
        recipe.RecipeItems = dataLocalStorage.RecipeItems;
        recipe.HashCode = dataLocalStorage.HashCode;

        var data = {};
        data.Recipe = recipe;
        data.GlobalId = "";
        return returnResponse(recipeId, 200, [], data);
    };

    var getRecipeItemsHashCode = function (recipeId, items) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return null;
        }
        var recipeItems = items || ((Vendd.RecipeLibrary.GetFullRecipeItems(recipeId) || {}).data || {}).RecipeItems;
        var hashCode = recipeId +
            (recipeItems.length > 0
                ? "_" + (_.map(_.sortBy(recipeItems, "IngredientId"), function (i) { return i.IngredientId + "_" + i.Quantity; }) || []).join("_")
                : "");
        return hashCode;
    };

    Vendd.RecipeLibrary.GetLocalStorageRecipeItemsHashCode = function (recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return null;
        }
        if (localStorage.getItem("configurator_" + recipeId) === null) {
            return null;
        }
        var dataLocalStorage = JSON.parse(localStorage.getItem("configurator_" + recipeId) || "{}");
        return dataLocalStorage.HashCode;
    }

    Vendd.RecipeLibrary.ClearLocalStorage = function (recipeId) {
        var recipe = _recipes[recipeId];
        if (!recipe) {
            return false;
        }
        if (localStorage.getItem("configurator_" + recipeId) !== null) {
            localStorage.removeItem("configurator_" + recipeId);
        }
        if (localStorage.getItem("globalId_" + recipeId) !== null) {
            localStorage.removeItem("globalId_" + recipeId);
        }
        return true;
    }

    Vendd.RecipeLibrary.ConvertToSavedModel = function (recipeId) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        var data = {};
        data = converModelToSaveDataModel(recipe) || {};
        data.Groups = converGroupsToSaveDataModel(recipe.Groups) || [];
        data.Ingredients = converIngedientToSaveDataModel(recipe.Ingredients) || [];
        data.RecipeItems = Vendd.RecipeLibrary.GetRecipeItems(recipeId).data.RecipeItems || [];
        data.Addons = converAddonsToSaveDataModel(recipe.Addons) || [];
        data.SubRecipes = _.map(
            _.filter(recipe.RecipeItems, function (r) { return r.SubRecipeId > 0 && _recipes[r.ProductItemId]; }) || [],
            function (ri) {
                return (Vendd.RecipeLibrary.ConvertToSavedModel(ri.ProductItemId) || {}).data || {};
            }) || [];
        return returnResponse(recipeId, 200, [], data);
    };

    var converAddonsToSaveDataModel = function (addons) {
        var model = _.map(addons, function (i) {
            return {
                AddonId: i.AddonId,
                Category: i.Category,
                Co2: i.Co2,
                Code: i.Code,
                Name: i.Name,
                Price: i.Price,
                PriceWithoutVat: i.PriceWithoutVat,
                RecipeId: i.RecipeId,
                Weight: i.Weight
            };
        });
        return model;
    };

    var converModelToSaveDataModel = function (m) {
        return {
            RecipeId: m.RecipeId,
            RecipeItemId: m.RecipeItemId,
            MinQuantity: m.MinQuantity,
            MaxQuantity: m.MaxQuantity,
            MaxFreeQuantity: m.MaxFreeQuantity,
            MaxReplaceQuantity: m.MaxReplaceQuantity,
            UnitPrice: m.UnitPrice
        };
    };

    var converGroupsToSaveDataModel = function (groups) {
        var model = _.map(groups, function (g) {
            return {
                Id: g.Id,
                MinQuantity: g.MinQuantity,
                MaxQuantity: g.MaxQuantity,
            };
        });
        return model;
    };

    var converIngedientToSaveDataModel = function (ingredients) {
        var model = _.map(ingredients, function (i) {
            return {
                IngredientId: i.IngredientId,
                Name: i.Name,
                GroupId: i.GroupId,
                Price: i.Price,
                Incompatibles: i.Incompatibles || [],
                Prerequisites: i.Prerequisites || [],
            };
        });
        return model;
    };

    function checkRestrictions(recipe) {
        return true;
    };

    function FixJSFloatBug(price) {
        return parseFloat((price || 0).toFixed(2));
    }

    Vendd.RecipeLibrary.GetIngredientsFromDMSCode = function (recipeId, dmscode) {
        var recipe = _recipes[recipeId];

        if (!recipe) {
            return returnResponse(recipeId, 500, [1000]);
        }
        var item = _.find(recipe.Ingredients, function (i) { return (i.DMSCode || "").toLowerCase() === (dmscode || "").toLowerCase() && (dmscode || "").toLowerCase() !== ""; });
        return returnResponse(recipeId, 200, [], item);
    };
    
    Vendd.RecipeLibrary.Tests = {
        0: function () {
            var _rec = 2;
            console.log(Vendd.RecipeLibrary.InitRecipe(null, _rec));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, _rec, 88694, 2));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, _rec, 88691, 1));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, _rec, 88691, 2));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, _rec, 88691, 2, true));
            console.log(Vendd.RecipeLibrary.RemoveIngredient(null, _rec, 88694));
            console.log(Vendd.RecipeLibrary.DeclareState(null, _rec));
            return "success";
        },
        1: function () {
            console.log(Vendd.RecipeLibrary.InitRecipe(null, 1));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88691, 2));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88694, 1));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88694, 2));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88694, 2, true));
            console.log(Vendd.RecipeLibrary.RemoveIngredient(null, 1, 88691));
            console.log(Vendd.RecipeLibrary.DeclareState(null, 1));
            return "success";
        },
        2: function () {
            console.log(Vendd.RecipeLibrary.InitRecipe(null, 1));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88694, 1));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88691, 2));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88694, 2));
            console.log(Vendd.RecipeLibrary.AddIngredient(null, 1, 88694, 2, true));
            console.log(Vendd.RecipeLibrary.RemoveIngredient(null, 1, 88691));
            console.log(Vendd.RecipeLibrary.DeclareState(null, 1));
            return "success";
        }
    };
    return Vendd;

})(Vendd || {});

var testModel = {};
